var _toConsumableArray = require("E:\\Code\\ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");
var _defineProperty2 = require("E:\\Code\\ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");
var _objectSpread = require("E:\\Code\\ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread");
var _classCallCheck = require("E:\\Code\\ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _possibleConstructorReturn = require("E:\\Code\\ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("E:\\Code\\ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");
var _createClass = require("E:\\Code\\ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
var _inherits = require("E:\\Code\\ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");
var _assertThisInitialized = require("E:\\Code\\ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");
/*! react-dual-listbox - v5.0.2 | 2023 */
(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("react"));else if (typeof define === 'function' && define.amd) define("ReactDualListbox", ["react"], factory);else if (typeof exports === 'object') exports["ReactDualListbox"] = factory(require("react"));else root["ReactDualListbox"] = factory(root["React"]);
})(self, function (__WEBPACK_EXTERNAL_MODULE__16__) {
  return (/******/function () {
      // webpackBootstrap
      /******/
      var __webpack_modules__ = [
        /* 0 */
      , /* 1 */
      /***/function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */
        });
        /* harmony import */
        var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
        /* harmony import */
        var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */
        var lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
        /* harmony import */
        var lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */
        var nanoid__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50);
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(29);
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */
        var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16);
        /* harmony import */
        var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */
        var _Action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17);
        /* harmony import */
        var _ListBox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41);
        /* harmony import */
        var _lang_default__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43);
        /* harmony import */
        var _shapes_iconsShape__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28);
        /* harmony import */
        var _shapes_languageShape__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39);
        /* harmony import */
        var _shapes_optionsShape__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44);
        /* harmony import */
        var _shapes_valueShape__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46);
        /* harmony import */
        var _util_indexesOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47);
        /* harmony import */
        var _util_swapOptions__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48);
        /* harmony import */
        var _constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(49);
        function _defineProperty(obj, key, value) {
          key = _toPropertyKey(key);
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _toPropertyKey(arg) {
          var key = _toPrimitive(arg, "string");
          return typeof key === "symbol" ? key : String(key);
        }
        function _toPrimitive(input, hint) {
          if (typeof input !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];
          if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (hint === "string" ? String : Number)(input);
        }
        var noop = function noop() {};
        var defaultFilter = function defaultFilter(option, filterInput) {
          if (filterInput === '') {
            return true;
          }
          return new RegExp(lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_1___default()(filterInput), 'i').test(option.label);
        };
        var defaultIcons = {
          moveLeft: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
            className: "rdl-icon rdl-icon-move-left"
          }),
          moveAllLeft: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
            className: "rdl-icon rdl-icon-move-all-left"
          }),
          moveRight: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
            className: "rdl-icon rdl-icon-move-right"
          }),
          moveAllRight: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
            className: "rdl-icon rdl-icon-move-all-right"
          }),
          moveBottom: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
            className: "rdl-icon rdl-icon-move-bottom"
          }),
          moveDown: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
            className: "rdl-icon rdl-icon-move-down"
          }),
          moveUp: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
            className: "rdl-icon rdl-icon-move-up"
          }),
          moveTop: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
            className: "rdl-icon rdl-icon-move-top"
          })
        };
        var DualListBox = /*#__PURE__*/function (_react__WEBPACK_IMPOR) {
          _inherits(DualListBox, _react__WEBPACK_IMPOR);
          _createClass(DualListBox, null, [{
            key: "flattenOptions",
            /**
             * Flatten an array of options to a simple list of values.
             *
             * @param {Array} options
             *
             * @returns {Array}
             */
            value: function flattenOptions(options) {
              var flattened = [];
              options.forEach(function (option) {
                if (option.value !== undefined) {
                  // Flatten single-level options
                  flattened.push(option.value);
                } else if (option.options !== undefined) {
                  // Flatten optgroup options
                  option.options.forEach(function (subOption) {
                    flattened.push(subOption.value);
                  });
                }
              });
              return flattened;
            }
            /**
             * @param {Object} props
             *
             * @returns {void}
             */
          }]);
          function DualListBox(props) {
            var _this2;
            _classCallCheck(this, DualListBox);
            _this2 = _possibleConstructorReturn(this, _getPrototypeOf(DualListBox).call(this, props));
            _this2.state = {
              filter: props.filter ? props.filter : {
                available: '',
                selected: ''
              },
              id: props.id || "rdl-".concat((0, nanoid__WEBPACK_IMPORTED_MODULE_13__.nanoid)()),
              selected: [],
              selections: {
                available: [],
                selected: []
              }
            };
            _this2.onActionClick = _this2.onActionClick.bind(_assertThisInitialized(_assertThisInitialized(_this2)));
            _this2.onOptionDoubleClick = _this2.onOptionDoubleClick.bind(_assertThisInitialized(_assertThisInitialized(_this2)));
            _this2.onOptionKeyUp = _this2.onOptionKeyUp.bind(_assertThisInitialized(_assertThisInitialized(_this2)));
            _this2.onFilterChange = _this2.onFilterChange.bind(_assertThisInitialized(_assertThisInitialized(_this2)));
            _this2.onSelectionChange = _this2.onSelectionChange.bind(_assertThisInitialized(_assertThisInitialized(_this2)));
            _this2.onHiddenFocus = _this2.onHiddenFocus.bind(_assertThisInitialized(_assertThisInitialized(_this2)));
            return _this2;
          }

          /**
           * @param {Object} props
           * @param {Object} prevState
           *
           * @returns {Object}
           */
          _createClass(DualListBox, [{
            key: "componentDidMount",
            /**
             * @returns {void}
             */
            value: function componentDidMount() {
              this.setValidityMessage();
            }
            /**
             * @returns {void}
             */
          }, {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
              this.setValidityMessage();
            }
            /**
             * @param {Array} selected The new selected values
             * @param {Array} selection The options the user highlighted (if any)
             * @param {string} controlKey The key for the control that fired this event.
             * @param {boolean} isRearrange Whether the change is a result of re-arrangement.
             *
             * @returns {void}
             */
          }, {
            key: "onChange",
            value: function onChange(selected, selection, controlKey) {
              var isRearrange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
              var _this$props = this.props,
                options = _this$props.options,
                simpleValue = _this$props.simpleValue,
                onChange = _this$props.onChange;
              var selections = this.state.selections;
              var userSelection = selection.map(function (_ref2) {
                var value = _ref2.value;
                return value;
              });
              if (simpleValue) {
                onChange(selected, userSelection, controlKey);
              } else {
                var complexValues = {
                  selected: [],
                  userSelection: []
                };
                var sourceValues = {
                  selected: selected,
                  userSelection: userSelection
                };

                // Reconstruct option objects for both the selected values and user selection
                Object.keys(sourceValues).forEach(function (key) {
                  // Reconstruct hierarchy from single-level options
                  // Note that complex values become expensive if there are several options
                  sourceValues[key].forEach(function (value) {
                    options.forEach(function (option) {
                      if (option.value) {
                        if (option.value === value) {
                          complexValues[key].push(option);
                        }
                      } else {
                        // Reconstruct optgroup options with those children
                        var subSelected = [];
                        option.options.forEach(function (subOption) {
                          if (subOption.value === value) {
                            subSelected.push(subOption);
                          }
                        });
                        if (subSelected.length > 0) {
                          complexValues[key].push({
                            label: option.label,
                            options: subSelected
                          });
                        }
                      }
                    });
                  });
                });
                onChange(complexValues.selected, complexValues.userSelection, controlKey);
              }

              // Reset selections after moving items for cleaner experience and to remove invalid values
              // Note that this should not occur for re-arrangement operations
              if (!isRearrange) {
                this.setState({
                  selections: _objectSpread({}, selections, _defineProperty2({}, controlKey, []))
                });
              }
            }
            /**
             * @param {string} direction
             * @param {boolean} isMoveAll
             *
             * @returns {void}
             */
          }, {
            key: "onActionClick",
            value: function onActionClick(_ref3) {
              var direction = _ref3.direction,
                isMoveAll = _ref3.isMoveAll;
              var options = this.props.options;
              var directionIsRight = direction === 'right';
              var sourceListBox = directionIsRight ? this.available : this.selected;
              var marked = this.getMarkedOptions(sourceListBox);
              var isRearrangement = false;
              var selected;
              if (['up', 'down'].indexOf(direction) > -1) {
                selected = this.rearrangeSelected(marked, direction);
                isRearrangement = true;
              } else if (['top', 'bottom'].indexOf(direction) > -1) {
                selected = this.rearrangeToExtremes(marked, direction);
                isRearrangement = true;
              } else if (isMoveAll) {
                selected = directionIsRight ? this.makeOptionsSelected(options) : this.makeOptionsUnselected(options);
              } else {
                selected = this.toggleHighlighted(marked, directionIsRight ? 'available' : 'selected');
              }
              this.onChange(selected, marked, directionIsRight ? 'available' : 'selected', isRearrangement);
            }
            /**
             * @param {Object} event
             * @param {string} controlKey
             *
             * @returns {void}
             */
          }, {
            key: "onOptionDoubleClick",
            value: function onOptionDoubleClick(event, controlKey) {
              var marked = this.getMarkedOptions(event.currentTarget);
              var selected = this.toggleHighlighted(marked, controlKey);
              this.onChange(selected, marked, controlKey);
            }
            /**
             * @param {Event} event
             * @param {string} controlKey
             *
             * @returns {void}
             */
          }, {
            key: "onOptionKeyUp",
            value: function onOptionKeyUp(event, controlKey) {
              var currentTarget = event.currentTarget,
                key = event.key;
              var moveKeys = this.props.moveKeys;
              if (moveKeys.indexOf(key) > -1) {
                var marked = this.getMarkedOptions(currentTarget);
                var selected = this.toggleHighlighted(marked, controlKey);
                this.onChange(selected, marked, controlKey);
              }
            }
            /**
             * @param {Object} event
             * @param {string} controlKey
             *
             * @returns {void}
             */
          }, {
            key: "onSelectionChange",
            value: function onSelectionChange(event, controlKey) {
              var selections = this.state.selections;
              var value = Array.from(event.target.options).filter(function (option) {
                return option.selected;
              }).map(function (option) {
                return option.value;
              });
              this.setState({
                selections: _objectSpread({}, selections, _defineProperty2({}, controlKey, value))
              });
            }
            /**
             * @param {Event} event
             *
             * @returns {void}
             */
          }, {
            key: "onFilterChange",
            value: function onFilterChange(event) {
              var onFilterChange = this.props.onFilterChange;
              var filter = this.state.filter;
              var newFilter = _objectSpread({}, filter, _defineProperty2({}, event.target.dataset.controlKey, event.target.value));
              if (onFilterChange) {
                onFilterChange(newFilter);
              } else {
                this.setState({
                  filter: newFilter
                });
              }
            }
            /**
             * Focus the selected list-box whenever a form flags this component as invalid.
             *
             * @returns {void}
             */
          }, {
            key: "onHiddenFocus",
            value: function onHiddenFocus() {
              this.available.focus();
            }
            /**
             * Converts a flat array to a key/value mapping.
             *
             * @param {Array} options
             *
             * @returns {Object}
             */
          }, {
            key: "getLabelMap",
            value: function getLabelMap(options) {
              var _this3 = this;
              var labelMap = {};
              options.forEach(function (option) {
                if (option.options !== undefined) {
                  labelMap = _objectSpread({}, labelMap, _this3.getLabelMap(option.options));
                } else {
                  labelMap[option.value] = option.label;
                }
              });
              return labelMap;
            }
            /**
             * Returns the highlighted options from a given element.
             *
             * @param {Object} element
             *
             * @returns {Array}
             */
          }, {
            key: "getMarkedOptions",
            value: function getMarkedOptions(element) {
              if (element === null) {
                return [];
              }
              return Array.from(element.options).filter(function (option) {
                return option.selected;
              }).map(function (option) {
                return {
                  index: parseInt(option.dataset.index, 10),
                  value: JSON.parse(option.dataset.realValue)
                };
              });
            }
            /**
             * Set the custom validity message when there is no selected option.
             *
             * @returns {void}
             */
          }, {
            key: "setValidityMessage",
            value: function setValidityMessage() {
              var _this$props2 = this.props,
                lang = _this$props2.lang,
                required = _this$props2.required;
              var selected = this.state.selected; // Irrelevant if not the caller has not made this component required
              if (!required) {
                return;
              }
              if (selected.length === 0) {
                this.hiddenInput.setCustomValidity(lang.requiredError);
              } else {
                this.hiddenInput.setCustomValidity('');
              }
            }
            /**
             * Re-arrange the marked options to move up or down in the selected list.
             *
             * @param {Array} markedOptions
             * @param {string} direction
             *
             * @returns {Array}
             */
          }, {
            key: "rearrangeSelected",
            value: function rearrangeSelected(markedOptions, direction) {
              var selected = this.state.selected;
              var newOrder = _toConsumableArray(selected);
              if (markedOptions.length === 0) {
                return newOrder;
              }
              if (direction === 'up') {
                // If all of the marked options are already as high as they can get, ignore the
                // re-arrangement request because they will end of swapping their order amongst
                // themselves.
                if (markedOptions[markedOptions.length - 1].index > markedOptions.length - 1) {
                  markedOptions.forEach(function (_ref4) {
                    var index = _ref4.index;
                    if (index > 0) {
                      newOrder = (0, _util_swapOptions__WEBPACK_IMPORTED_MODULE_11__["default"])(index, index - 1)(newOrder);
                    }
                  });
                }
              } else if (direction === 'down') {
                // Similar to the above, if all of the marked options are already as low as they can
                // get, ignore the re-arrangement request.
                if (markedOptions[0].index < selected.length - markedOptions.length) {
                  markedOptions.reverse().forEach(function (_ref5) {
                    var index = _ref5.index;
                    if (index < selected.length - 1) {
                      newOrder = (0, _util_swapOptions__WEBPACK_IMPORTED_MODULE_11__["default"])(index, index + 1)(newOrder);
                    }
                  });
                }
              }
              return newOrder;
            }
            /**
             * Move the marked options to the top or bottom of the selected options.
             *
             * @param {Array} markedOptions
             * @param {string} direction 'top' | 'bottom'
             *
             * @returns {Array}
             */
          }, {
            key: "rearrangeToExtremes",
            value: function rearrangeToExtremes(markedOptions, direction) {
              var selectedItems = this.state.selected;
              var unmarked = _toConsumableArray(selectedItems);

              // Filter out marked options
              markedOptions.forEach(function (_ref6) {
                var index = _ref6.index;
                unmarked[index] = null;
              });
              unmarked = unmarked.filter(function (v) {
                return v !== null;
              });

              // Condense marked options raw values
              var marked = markedOptions.map(function (_ref7) {
                var index = _ref7.index;
                return selectedItems[index];
              });
              if (direction === 'top') {
                return [].concat(_toConsumableArray(marked), _toConsumableArray(unmarked));
              }
              return [].concat(_toConsumableArray(unmarked), _toConsumableArray(marked));
            }
            /**
             * Make all the given options selected, appending them after the existing selections.
             *
             * @param {Array} options
             *
             * @returns {Array}
             */
          }, {
            key: "makeOptionsSelected",
            value: function makeOptionsSelected(options) {
              var selected = this.state.selected;
              var availableOptions = this.filterAvailable(options);
              return [].concat(_toConsumableArray(selected), _toConsumableArray(this.makeOptionsSelectedRecursive(availableOptions)));
            }
            /**
             * Recursively make the given set of options selected.
             *
             * @param {Array} options
             *
             * @returns {Array}
             */
          }, {
            key: "makeOptionsSelectedRecursive",
            value: function makeOptionsSelectedRecursive(options) {
              var _this4 = this;
              var newSelected = [];
              options.forEach(function (option) {
                // Skip disabled options
                if (option.disabled) {
                  return;
                }
                if (option.options !== undefined) {
                  newSelected = [].concat(_toConsumableArray(newSelected), _toConsumableArray(_this4.makeOptionsSelectedRecursive(option.options)));
                } else {
                  newSelected.push(option.value);
                }
              });
              return newSelected;
            }
            /**
             * Make all the given options unselected, except for those disabled.
             *
             * @param {Array} options
             *
             * @returns {Array}
             */
          }, {
            key: "makeOptionsUnselected",
            value: function makeOptionsUnselected(options) {
              var selected = this.filterSelected(options, true);
              return this.makeOptionsUnselectedRecursive(selected);
            }
            /**
             * Recursively unselect the given options, except for those disabled.
             *
             * @param {Array} selectedOptions
             *
             * @returns {Array}
             */
          }, {
            key: "makeOptionsUnselectedRecursive",
            value: function makeOptionsUnselectedRecursive(selectedOptions) {
              var _this5 = this;
              var newSelected = [];
              selectedOptions.forEach(function (option) {
                if (option.options !== undefined) {
                  // Traverse any parents for leaf options
                  newSelected = [].concat(_toConsumableArray(newSelected), _toConsumableArray(_this5.makeOptionsUnselectedRecursive(option.options)));
                } else if (option.disabled) {
                  // Preserve only disabled options
                  newSelected.push(option.value);
                }
              });
              return newSelected;
            }
            /**
             * Toggle a set of highlighted elements.
             *
             * @param {Array} toggleItems
             * @param {string} controlKey
             *
             * @returns {Array}
             */
          }, {
            key: "toggleHighlighted",
            value: function toggleHighlighted(toggleItems, controlKey) {
              var allowDuplicates = this.props.allowDuplicates;
              var selected = this.state.selected;
              var selectedItems = selected.slice(0);
              var toggleItemsMap = _objectSpread({}, selectedItems);

              // Add/remove the individual items based on previous state
              toggleItems.forEach(function (_ref8) {
                var value = _ref8.value,
                  index = _ref8.index;
                var inSelectedOptions = selectedItems.indexOf(value) > -1;
                if (inSelectedOptions && (!allowDuplicates || controlKey === 'selected')) {
                  // Toggled items that were previously selected are removed unless `allowDuplicates`
                  // is set to true or the option was sourced from the selected ListBox. We use an
                  // object mapping such that we can remove the exact index of the selected items
                  // without the array re-arranging itself.
                  delete toggleItemsMap[index];
                } else {
                  selectedItems.push(value);
                }
              });

              // Convert object mapping back to an array
              if (controlKey === 'selected') {
                return Object.keys(toggleItemsMap).map(function (key) {
                  return toggleItemsMap[key];
                });
              }
              return selectedItems;
            }
            /**
             * Filter the given options by a ListBox filtering function and the user search string.
             *
             * @param {Array} options
             * @param {Function} filterer
             * @param {string} filterInput
             * @param {boolean} forceAllow
             *
             * @returns {Array}
             */
          }, {
            key: "filterOptions",
            value: function filterOptions(options, filterer, filterInput) {
              var _this6 = this;
              var forceAllow = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
              var _this$props3 = this.props,
                canFilter = _this$props3.canFilter,
                filterCallback = _this$props3.filterCallback;
              var filtered = [];
              options.forEach(function (option) {
                if (option.options !== undefined) {
                  // Recursively filter any children
                  var children = _this6.filterOptions(option.options, filterer, filterInput,
                  // If the optgroup passes the filter, pre-clear all available children
                  forceAllow || filterCallback(option, filterInput));
                  if (children.length > 0) {
                    filtered.push(_objectSpread({}, option, {
                      options: children
                    }));
                  }
                } else {
                  var subFiltered = [];
                  // Run the main, non-search filter function against the given item
                  var filterResult = filterer(option);
                  if (Array.isArray(filterResult)) {
                    // The selected list box will be filtered by whether the given options have a
                    // selected index. This index will later be used when removing user selections.
                    // This index is particularly relevant for duplicate selections, as we want to
                    // preserve the removal order properly when `preserveSelectOrder` is set to
                    // true, rather than simply removing the first value encountered.
                    filterResult.forEach(function (index) {
                      subFiltered.push(_objectSpread({}, option, {
                        selectedIndex: index
                      }));
                    });
                  } else if (filterResult) {
                    // Available options are much simpler and are merely filtered by a boolean
                    subFiltered.push(option);
                  }

                  // If any matched options go through, optionally apply user filtering and then add
                  // these options to the filtered list. The text search filtering is applied AFTER
                  // the main filtering to prevent unnecessary calls to the filterCallback function.
                  if (subFiltered.length > 0) {
                    if (canFilter && !forceAllow && !filterCallback(option, filterInput)) {
                      return;
                    }
                    subFiltered.forEach(function (subItem) {
                      filtered.push(subItem);
                    });
                  }
                }
              });
              return filtered;
            }
            /**
             * Filter the available options.
             *
             * @param {Array} options
             * @param {boolean} noSearchFilter Ignore the search filter.
             *
             * @returns {Array}
             */
          }, {
            key: "filterAvailable",
            value: function filterAvailable(options) {
              var noSearchFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var _this$props4 = this.props,
                allowDuplicates = _this$props4.allowDuplicates,
                available = _this$props4.available,
                simpleValue = _this$props4.simpleValue;
              var _this$state = this.state,
                availableFilter = _this$state.filter.available,
                selected = _this$state.selected;
              var filters = [];

              // Apply user-defined available restrictions, if any
              if (available !== undefined) {
                var availableOptions = simpleValue ? available : DualListBox.flattenOptions(available);
                filters.push(function (option) {
                  return availableOptions.indexOf(option.value) >= 0;
                });
              }

              // If duplicates are not allowed, filter out selected options
              if (!allowDuplicates) {
                filters.push(function (option) {
                  return selected.indexOf(option.value) < 0;
                });
              }

              // Apply each filter function on the option
              var filterer = function filterer(option) {
                return filters.reduce(function (previousValue, filter) {
                  return previousValue && filter(option);
                }, true);
              };
              return this.filterOptions(options, filterer, availableFilter, noSearchFilter);
            }
            /**
             * Filter the selected options.
             *
             * @param {Array} options
             * @param {boolean} noSearchFilter Ignore the search filter.
             *
             * @returns {Array}
             */
          }, {
            key: "filterSelected",
            value: function filterSelected(options) {
              var noSearchFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var preserveSelectOrder = this.props.preserveSelectOrder;
              var _this$state2 = this.state,
                selectedFilter = _this$state2.filter.selected,
                selected = _this$state2.selected;
              if (preserveSelectOrder) {
                return this.filterSelectedByOrder(options);
              }

              // Order the selections by the default order
              return this.filterOptions(options, function (option) {
                return (0, _util_indexesOf__WEBPACK_IMPORTED_MODULE_10__["default"])(selected, option.value);
              }, selectedFilter, noSearchFilter);
            }
            /**
             * Preserve the selection order. This drops the opt-group associations.
             *
             * @param {Array} options
             *
             * @returns {Array}
             */
          }, {
            key: "filterSelectedByOrder",
            value: function filterSelectedByOrder(options) {
              var _this$props5 = this.props,
                canFilter = _this$props5.canFilter,
                filterCallback = _this$props5.filterCallback;
              var _this$state3 = this.state,
                selectedFilter = _this$state3.filter.selected,
                selected = _this$state3.selected;
              var labelMap = this.getLabelMap(options);
              var selectedOptions = selected.map(function (value, index) {
                return {
                  value: value,
                  label: labelMap[value],
                  selectedIndex: index
                };
              });
              if (canFilter) {
                return selectedOptions.filter(function (selectedOption) {
                  return filterCallback(selectedOption, selectedFilter);
                });
              }
              return selectedOptions;
            }
            /**
             * @param {Array} options
             *
             * @returns {Array}
             */
          }, {
            key: "renderOptions",
            value: function renderOptions(options) {
              var _this7 = this;
              var allowDuplicates = this.props.allowDuplicates;
              var id = this.state.id;
              return options.map(function (option, index) {
                var key = !allowDuplicates ? "".concat(option.value, "-").concat(option.label) : "".concat(option.value, "-").concat(option.label, "-").concat(index);
                if (option.options !== undefined) {
                  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("optgroup", {
                    key: key,
                    disabled: option.disabled,
                    id: "".concat(id, "-optgroup-").concat(option.label),
                    label: option.label,
                    title: option.title
                  }, _this7.renderOptions(option.options));
                }

                // If duplicates are allow, append the index to keep each entry unique such that the
                // controlled component can easily update its state.
                var value = !allowDuplicates ? option.value : "".concat(option.value, "-").concat(index);
                return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("option", {
                  key: key,
                  "data-index": option.selectedIndex,
                  "data-real-value": JSON.stringify(option.value),
                  disabled: option.disabled,
                  id: "".concat(id, "-option-").concat(option.value),
                  title: option.title,
                  value: value
                }, option.label);
              });
            }
            /**
             * @param {string} controlKey
             * @param {Array} options
             * @param {function} ref
             * @param {ReactElement} actions
             *
             * @returns {ReactElement}
             */
          }, {
            key: "renderListBox",
            value: function renderListBox(controlKey, options, ref, actions) {
              var _this8 = this;
              var _this$props6 = this.props,
                alignActions = _this$props6.alignActions,
                canFilter = _this$props6.canFilter,
                disabled = _this$props6.disabled,
                lang = _this$props6.lang,
                showHeaderLabels = _this$props6.showHeaderLabels,
                showNoOptionsText = _this$props6.showNoOptionsText;
              var _this$state4 = this.state,
                filter = _this$state4.filter,
                id = _this$state4.id,
                selections = _this$state4.selections; // Wrap event handlers with a controlKey reference
              var wrapHandler = function wrapHandler(handler) {
                return function (event) {
                  return handler(event, controlKey);
                };
              };
              return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_ListBox__WEBPACK_IMPORTED_MODULE_4__["default"], {
                actions: alignActions === _constants__WEBPACK_IMPORTED_MODULE_12__.ALIGNMENTS.TOP ? actions : null,
                canFilter: canFilter,
                controlKey: controlKey,
                disabled: disabled,
                filterValue: filter[controlKey],
                id: id,
                inputRef: function inputRef(c) {
                  _this8[controlKey] = c;
                  if (ref) {
                    ref(c);
                  }
                },
                lang: lang,
                selections: selections[controlKey],
                showHeaderLabels: showHeaderLabels,
                showNoOptionsText: showNoOptionsText,
                onDoubleClick: wrapHandler(this.onOptionDoubleClick),
                onFilterChange: wrapHandler(this.onFilterChange),
                onKeyUp: wrapHandler(this.onOptionKeyUp),
                onSelectionChange: wrapHandler(this.onSelectionChange)
              }, options);
            }
            /**
             * @returns {ReactNode}
             */
          }, {
            key: "render",
            value: function render() {
              var _objectSpread5,
                _this9 = this;
              var _this = this;
              var _this$props7 = this.props,
                alignActions = _this$props7.alignActions,
                availableRef = _this$props7.availableRef,
                canFilter = _this$props7.canFilter,
                className = _this$props7.className,
                disabled = _this$props7.disabled,
                htmlDir = _this$props7.htmlDir,
                icons = _this$props7.icons,
                iconsClass = _this$props7.iconsClass,
                lang = _this$props7.lang,
                name = _this$props7.name,
                options = _this$props7.options,
                preserveSelectOrder = _this$props7.preserveSelectOrder,
                required = _this$props7.required,
                selectedRef = _this$props7.selectedRef,
                showHeaderLabels = _this$props7.showHeaderLabels,
                showOrderButtons = _this$props7.showOrderButtons;
              var _this$state5 = this.state,
                id = _this$state5.id,
                selected = _this$state5.selected;
              var availableOptions = this.renderOptions(this.filterAvailable(options));
              var selectedOptions = this.renderOptions(this.filterSelected(options));
              var makeAction = function makeAction(direction) {
                var isMoveAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_Action__WEBPACK_IMPORTED_MODULE_3__["default"], {
                  direction: direction,
                  disabled: disabled,
                  icons: icons,
                  id: id,
                  isMoveAll: isMoveAll,
                  lang: lang,
                  onClick: _this.onActionClick
                });
              };
              var actionsRight = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
                className: "rdl-actions-right"
              }, makeAction('right', true), makeAction('right'));
              var actionsLeft = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
                className: "rdl-actions-left"
              }, makeAction('left'), makeAction('left', true));
              var rootClassName = classnames__WEBPACK_IMPORTED_MODULE_0___default()(_objectSpread((_objectSpread5 = {
                'react-dual-listbox': true
              }, _defineProperty2(_objectSpread5, "rdl-icons-".concat(iconsClass), true), _defineProperty2(_objectSpread5, 'rdl-has-filter', canFilter), _defineProperty2(_objectSpread5, 'rdl-has-header', showHeaderLabels), _defineProperty2(_objectSpread5, 'rdl-align-top', alignActions === _constants__WEBPACK_IMPORTED_MODULE_12__.ALIGNMENTS.TOP), _objectSpread5), className && _defineProperty2({}, className, true)));
              var hiddenValue = selected.join(',');
              return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
                className: rootClassName,
                dir: htmlDir,
                id: id
              }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
                className: "rdl-controls"
              }, this.renderListBox('available', availableOptions, availableRef, actionsRight), alignActions === _constants__WEBPACK_IMPORTED_MODULE_12__.ALIGNMENTS.MIDDLE ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
                className: "rdl-actions"
              }, actionsRight, actionsLeft) : null, this.renderListBox('selected', selectedOptions, selectedRef, actionsLeft), preserveSelectOrder && showOrderButtons ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
                className: "rdl-actions"
              }, makeAction('top'), makeAction('up'), makeAction('down'), makeAction('bottom')) : null), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("input", {
                className: "rdl-hidden-input",
                disabled: disabled,
                name: name,
                ref: function ref(c) {
                  _this9.hiddenInput = c;
                },
                required: required,
                type: required ? 'text' : 'hidden',
                value: hiddenValue,
                onChange: noop,
                onFocus: this.onHiddenFocus
              }));
            }
          }], [{
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(_ref, prevState) {
              var filter = _ref.filter,
                id = _ref.id,
                selected = _ref.selected,
                simpleValue = _ref.simpleValue;
              var newSelected = simpleValue ? selected : DualListBox.flattenOptions(selected);
              var newState = _objectSpread({}, prevState, {
                selected: newSelected
              });

              // Allow user to control filter, if so desired
              if (filter !== null) {
                newState.filter = filter;
              }

              // Allow user to control ID, if so desired
              if (id !== null) {
                newState.id = id;
              }
              return newState;
            }
          }]);
          return DualListBox;
        }(react__WEBPACK_IMPORTED_MODULE_2__.Component);
        _defineProperty(DualListBox, "propTypes", {
          options: _shapes_optionsShape__WEBPACK_IMPORTED_MODULE_8__["default"].isRequired,
          onChange: prop_types__WEBPACK_IMPORTED_MODULE_14___default().func.isRequired,
          alignActions: prop_types__WEBPACK_IMPORTED_MODULE_14___default().oneOf([_constants__WEBPACK_IMPORTED_MODULE_12__.ALIGNMENTS.MIDDLE, _constants__WEBPACK_IMPORTED_MODULE_12__.ALIGNMENTS.TOP]),
          allowDuplicates: prop_types__WEBPACK_IMPORTED_MODULE_14___default().bool,
          available: _shapes_valueShape__WEBPACK_IMPORTED_MODULE_9__["default"],
          availableRef: prop_types__WEBPACK_IMPORTED_MODULE_14___default().func,
          canFilter: prop_types__WEBPACK_IMPORTED_MODULE_14___default().bool,
          className: prop_types__WEBPACK_IMPORTED_MODULE_14___default().string,
          disabled: prop_types__WEBPACK_IMPORTED_MODULE_14___default().bool,
          filter: prop_types__WEBPACK_IMPORTED_MODULE_14___default().shape({
            available: prop_types__WEBPACK_IMPORTED_MODULE_14___default().string.isRequired,
            selected: prop_types__WEBPACK_IMPORTED_MODULE_14___default().string.isRequired
          }),
          filterCallback: prop_types__WEBPACK_IMPORTED_MODULE_14___default().func,
          htmlDir: prop_types__WEBPACK_IMPORTED_MODULE_14___default().string,
          icons: _shapes_iconsShape__WEBPACK_IMPORTED_MODULE_6__["default"],
          iconsClass: prop_types__WEBPACK_IMPORTED_MODULE_14___default().string,
          id: prop_types__WEBPACK_IMPORTED_MODULE_14___default().string,
          lang: _shapes_languageShape__WEBPACK_IMPORTED_MODULE_7__["default"],
          moveKeys: prop_types__WEBPACK_IMPORTED_MODULE_14___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_14___default().string),
          name: prop_types__WEBPACK_IMPORTED_MODULE_14___default().string,
          preserveSelectOrder: prop_types__WEBPACK_IMPORTED_MODULE_14___default().bool,
          required: prop_types__WEBPACK_IMPORTED_MODULE_14___default().bool,
          selected: _shapes_valueShape__WEBPACK_IMPORTED_MODULE_9__["default"],
          selectedRef: prop_types__WEBPACK_IMPORTED_MODULE_14___default().func,
          showHeaderLabels: prop_types__WEBPACK_IMPORTED_MODULE_14___default().bool,
          showNoOptionsText: prop_types__WEBPACK_IMPORTED_MODULE_14___default().bool,
          showOrderButtons: prop_types__WEBPACK_IMPORTED_MODULE_14___default().bool,
          simpleValue: prop_types__WEBPACK_IMPORTED_MODULE_14___default().bool,
          onFilterChange: prop_types__WEBPACK_IMPORTED_MODULE_14___default().func
        });
        _defineProperty(DualListBox, "defaultProps", {
          alignActions: _constants__WEBPACK_IMPORTED_MODULE_12__.ALIGNMENTS.MIDDLE,
          allowDuplicates: false,
          available: undefined,
          availableRef: null,
          canFilter: false,
          className: null,
          disabled: false,
          filter: null,
          filterCallback: defaultFilter,
          htmlDir: 'ltr',
          icons: defaultIcons,
          iconsClass: 'fa5',
          id: null,
          lang: _lang_default__WEBPACK_IMPORTED_MODULE_5__["default"],
          moveKeys: [_constants__WEBPACK_IMPORTED_MODULE_12__.KEYS.SPACEBAR, _constants__WEBPACK_IMPORTED_MODULE_12__.KEYS.ENTER],
          name: null,
          preserveSelectOrder: null,
          required: false,
          selected: [],
          selectedRef: null,
          simpleValue: true,
          showHeaderLabels: false,
          showNoOptionsText: false,
          showOrderButtons: false,
          onFilterChange: null
        });
        /* harmony default export */
        var __WEBPACK_DEFAULT_EXPORT__ = DualListBox;

        /***/
      }, /* 2 */
      /***/function (module, exports) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
                                                                         Copyright (c) 2018 Jed Watson.
                                                                         Licensed under the MIT License (MIT), see
                                                                         http://jedwatson.github.io/classnames
                                                                         */
        /* global define */

        (function () {
          'use strict';

          var hasOwn = {}.hasOwnProperty;
          var nativeCodeString = '[native code]';
          function classNames() {
            var classes = [];
            for (var i = 0; i < arguments.length; i++) {
              var arg = arguments[i];
              if (!arg) continue;
              var argType = typeof arg;
              if (argType === 'string' || argType === 'number') {
                classes.push(arg);
              } else if (Array.isArray(arg)) {
                if (arg.length) {
                  var inner = classNames.apply(null, arg);
                  if (inner) {
                    classes.push(inner);
                  }
                }
              } else if (argType === 'object') {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
                  classes.push(arg.toString());
                  continue;
                }
                for (var key in arg) {
                  if (hasOwn.call(arg, key) && arg[key]) {
                    classes.push(key);
                  }
                }
              }
            }
            return classes.join(' ');
          }
          if (true && module.exports) {
            classNames.default = classNames;
            module.exports = classNames;
          } else if (true) {
            // register as 'classnames', consistent with npm package name
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
              return classNames;
            }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          } else {}
        })();

        /***/
      }, /* 3 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        var toString = __webpack_require__(4);

        /**
         * Used to match `RegExp`
         * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
         */
        var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
          reHasRegExpChar = RegExp(reRegExpChar.source);

        /**
         * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
         * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to escape.
         * @returns {string} Returns the escaped string.
         * @example
         *
         * _.escapeRegExp('[lodash](https://lodash.com/)');
         * // => '\[lodash\]\(https://lodash\.com/\)'
         */
        function escapeRegExp(string) {
          string = toString(string);
          return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        module.exports = escapeRegExp;

        /***/
      }, /* 4 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        var baseToString = __webpack_require__(5);

        /**
         * Converts `value` to a string. An empty string is returned for `null`
         * and `undefined` values. The sign of `-0` is preserved.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {string} Returns the converted string.
         * @example
         *
         * _.toString(null);
         * // => ''
         *
         * _.toString(-0);
         * // => '-0'
         *
         * _.toString([1, 2, 3]);
         * // => '1,2,3'
         */
        function toString(value) {
          return value == null ? '' : baseToString(value);
        }
        module.exports = toString;

        /***/
      }, /* 5 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        var Symbol = __webpack_require__(6),
          arrayMap = __webpack_require__(9),
          isArray = __webpack_require__(10),
          isSymbol = __webpack_require__(11);

        /** Used as references for various `Number` constants. */
        var INFINITY = 1 / 0;

        /** Used to convert symbols to primitives and strings. */
        var symbolProto = Symbol ? Symbol.prototype : undefined,
          symbolToString = symbolProto ? symbolProto.toString : undefined;

        /**
         * The base implementation of `_.toString` which doesn't convert nullish
         * values to empty strings.
         *
         * @private
         * @param {*} value The value to process.
         * @returns {string} Returns the string.
         */
        function baseToString(value) {
          // Exit early for strings to avoid a performance hit in some environments.
          if (typeof value == 'string') {
            return value;
          }
          if (isArray(value)) {
            // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
          }
          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : '';
          }
          var result = value + '';
          return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        module.exports = baseToString;

        /***/
      }, /* 6 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        var root = __webpack_require__(7);

        /** Built-in value references. */
        var Symbol = root.Symbol;
        module.exports = Symbol;

        /***/
      }, /* 7 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        var freeGlobal = __webpack_require__(8);

        /** Detect free variable `self`. */
        var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

        /** Used as a reference to the global object. */
        var root = freeGlobal || freeSelf || Function('return this')();
        module.exports = root;

        /***/
      }, /* 8 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        /** Detect free variable `global` from Node.js. */
        var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;
        module.exports = freeGlobal;

        /***/
      }, /* 9 */
      /***/function (module) {
        /**
         * A specialized version of `_.map` for arrays without support for iteratee
         * shorthands.
         *
         * @private
         * @param {Array} [array] The array to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array} Returns the new mapped array.
         */
        function arrayMap(array, iteratee) {
          var index = -1,
            length = array == null ? 0 : array.length,
            result = Array(length);
          while (++index < length) {
            result[index] = iteratee(array[index], index, array);
          }
          return result;
        }
        module.exports = arrayMap;

        /***/
      }, /* 10 */
      /***/function (module) {
        /**
         * Checks if `value` is classified as an `Array` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array, else `false`.
         * @example
         *
         * _.isArray([1, 2, 3]);
         * // => true
         *
         * _.isArray(document.body.children);
         * // => false
         *
         * _.isArray('abc');
         * // => false
         *
         * _.isArray(_.noop);
         * // => false
         */
        var isArray = Array.isArray;
        module.exports = isArray;

        /***/
      }, /* 11 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        var baseGetTag = __webpack_require__(12),
          isObjectLike = __webpack_require__(15);

        /** `Object#toString` result references. */
        var symbolTag = '[object Symbol]';

        /**
         * Checks if `value` is classified as a `Symbol` primitive or object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
         * @example
         *
         * _.isSymbol(Symbol.iterator);
         * // => true
         *
         * _.isSymbol('abc');
         * // => false
         */
        function isSymbol(value) {
          return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        module.exports = isSymbol;

        /***/
      }, /* 12 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        var Symbol = __webpack_require__(6),
          getRawTag = __webpack_require__(13),
          objectToString = __webpack_require__(14);

        /** `Object#toString` result references. */
        var nullTag = '[object Null]',
          undefinedTag = '[object Undefined]';

        /** Built-in value references. */
        var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

        /**
         * The base implementation of `getTag` without fallbacks for buggy environments.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the `toStringTag`.
         */
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
        }
        module.exports = baseGetTag;

        /***/
      }, /* 13 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        var Symbol = __webpack_require__(6);

        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */
        var nativeObjectToString = objectProto.toString;

        /** Built-in value references. */
        var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

        /**
         * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the raw `toStringTag`.
         */
        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag),
            tag = value[symToStringTag];
          try {
            value[symToStringTag] = undefined;
            var unmasked = true;
          } catch (e) {}
          var result = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result;
        }
        module.exports = getRawTag;

        /***/
      }, /* 14 */
      /***/function (module) {
        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */
        var nativeObjectToString = objectProto.toString;

        /**
         * Converts `value` to a string using `Object.prototype.toString`.
         *
         * @private
         * @param {*} value The value to convert.
         * @returns {string} Returns the converted string.
         */
        function objectToString(value) {
          return nativeObjectToString.call(value);
        }
        module.exports = objectToString;

        /***/
      }, /* 15 */
      /***/function (module) {
        /**
         * Checks if `value` is object-like. A value is object-like if it's not `null`
         * and has a `typeof` result of "object".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
         * @example
         *
         * _.isObjectLike({});
         * // => true
         *
         * _.isObjectLike([1, 2, 3]);
         * // => true
         *
         * _.isObjectLike(_.noop);
         * // => false
         *
         * _.isObjectLike(null);
         * // => false
         */
        function isObjectLike(value) {
          return value != null && typeof value == 'object';
        }
        module.exports = isObjectLike;

        /***/
      }, /* 16 */
      /***/function (module) {
        "use strict";

        module.exports = __WEBPACK_EXTERNAL_MODULE__16__;

        /***/
      }, /* 17 */
      /***/function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */
        });
        /* harmony import */
        var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
        /* harmony import */
        var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */
        var lodash_kebabCase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18);
        /* harmony import */
        var lodash_kebabCase__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_kebabCase__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29);
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */
        var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16);
        /* harmony import */
        var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */
        var _shapes_iconsShape__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28);
        /* harmony import */
        var _shapes_languageShape__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39);
        /* harmony import */
        var _util_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40);
        var propTypes = {
          direction: prop_types__WEBPACK_IMPORTED_MODULE_6___default().oneOf(['left', 'right', 'up', 'down', 'top', 'bottom']).isRequired,
          disabled: prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool.isRequired,
          icons: _shapes_iconsShape__WEBPACK_IMPORTED_MODULE_3__["default"].isRequired,
          id: prop_types__WEBPACK_IMPORTED_MODULE_6___default().string.isRequired,
          lang: _shapes_languageShape__WEBPACK_IMPORTED_MODULE_4__["default"].isRequired,
          onClick: prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired,
          isMoveAll: prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool
        };
        var defaultProps = {
          isMoveAll: false
        };

        /**
         * @returns {ReactNode}
         */
        function Action(props) {
          /**
           * @returns {void}
           */
          function onClick() {
            var direction = props.direction,
              isMoveAll = props.isMoveAll,
              parentOnClick = props.onClick;
            parentOnClick({
              direction: direction,
              isMoveAll: isMoveAll
            });
          }

          /**
           * @returns {string}
           */
          function getActionKey() {
            var direction = props.direction,
              isMoveAll = props.isMoveAll;
            return "move".concat(isMoveAll ? 'All' : '').concat((0, _util_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_5__["default"])(direction));
          }

          /**
           * @returns {string}
           */
          function getId(classKey) {
            var id = props.id;
            return "".concat(id, "-").concat(classKey);
          }

          /**
           * @param {string} actionKey
           *
           * @returns {string}
           */
          function getLabel(actionKey) {
            var lang = props.lang;
            return lang[actionKey];
          }

          /**
           * @param {string} actionKey
           *
           * @returns {*}
           */
          function renderIcons(actionKey) {
            var icons = props.icons;
            return icons[actionKey];
          }
          var disabled = props.disabled;
          var actionKey = getActionKey();
          var classKey = lodash_kebabCase__WEBPACK_IMPORTED_MODULE_1___default()(actionKey);
          var id = getId(classKey);
          var label = getLabel(actionKey);
          var className = classnames__WEBPACK_IMPORTED_MODULE_0___default()(_defineProperty2({
            'rdl-btn': true,
            'rdl-move': true
          }, "rdl-".concat(classKey), true));
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("button", {
            "aria-label": label,
            className: className,
            disabled: disabled,
            id: id,
            title: label,
            type: "button",
            onClick: onClick
          }, renderIcons(actionKey));
        }
        Action.propTypes = propTypes;
        Action.defaultProps = defaultProps;
        /* harmony default export */
        var __WEBPACK_DEFAULT_EXPORT__ = Action;

        /***/
      }, /* 18 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        var createCompounder = __webpack_require__(19);

        /**
         * Converts `string` to
         * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the kebab cased string.
         * @example
         *
         * _.kebabCase('Foo Bar');
         * // => 'foo-bar'
         *
         * _.kebabCase('fooBar');
         * // => 'foo-bar'
         *
         * _.kebabCase('__FOO_BAR__');
         * // => 'foo-bar'
         */
        var kebabCase = createCompounder(function (result, word, index) {
          return result + (index ? '-' : '') + word.toLowerCase();
        });
        module.exports = kebabCase;

        /***/
      }, /* 19 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        var arrayReduce = __webpack_require__(20),
          deburr = __webpack_require__(21),
          words = __webpack_require__(24);

        /** Used to compose unicode capture groups. */
        var rsApos = "['\u2019]";

        /** Used to match apostrophes. */
        var reApos = RegExp(rsApos, 'g');

        /**
         * Creates a function like `_.camelCase`.
         *
         * @private
         * @param {Function} callback The function to combine each word.
         * @returns {Function} Returns the new compounder function.
         */
        function createCompounder(callback) {
          return function (string) {
            return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
          };
        }
        module.exports = createCompounder;

        /***/
      }, /* 20 */
      /***/function (module) {
        /**
         * A specialized version of `_.reduce` for arrays without support for
         * iteratee shorthands.
         *
         * @private
         * @param {Array} [array] The array to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @param {*} [accumulator] The initial value.
         * @param {boolean} [initAccum] Specify using the first element of `array` as
         *  the initial value.
         * @returns {*} Returns the accumulated value.
         */
        function arrayReduce(array, iteratee, accumulator, initAccum) {
          var index = -1,
            length = array == null ? 0 : array.length;
          if (initAccum && length) {
            accumulator = array[++index];
          }
          while (++index < length) {
            accumulator = iteratee(accumulator, array[index], index, array);
          }
          return accumulator;
        }
        module.exports = arrayReduce;

        /***/
      }, /* 21 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        var deburrLetter = __webpack_require__(22),
          toString = __webpack_require__(4);

        /** Used to match Latin Unicode letters (excluding mathematical operators). */
        var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

        /** Used to compose unicode character classes. */
        var rsComboMarksRange = "\\u0300-\\u036f",
          reComboHalfMarksRange = "\\ufe20-\\ufe2f",
          rsComboSymbolsRange = "\\u20d0-\\u20ff",
          rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

        /** Used to compose unicode capture groups. */
        var rsCombo = '[' + rsComboRange + ']';

        /**
         * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
         * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
         */
        var reComboMark = RegExp(rsCombo, 'g');

        /**
         * Deburrs `string` by converting
         * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
         * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
         * letters to basic Latin letters and removing
         * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to deburr.
         * @returns {string} Returns the deburred string.
         * @example
         *
         * _.deburr('déjà vu');
         * // => 'deja vu'
         */
        function deburr(string) {
          string = toString(string);
          return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        module.exports = deburr;

        /***/
      }, /* 22 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        var basePropertyOf = __webpack_require__(23);

        /** Used to map Latin Unicode letters to basic Latin letters. */
        var deburredLetters = {
          // Latin-1 Supplement block.
          '\xc0': 'A',
          '\xc1': 'A',
          '\xc2': 'A',
          '\xc3': 'A',
          '\xc4': 'A',
          '\xc5': 'A',
          '\xe0': 'a',
          '\xe1': 'a',
          '\xe2': 'a',
          '\xe3': 'a',
          '\xe4': 'a',
          '\xe5': 'a',
          '\xc7': 'C',
          '\xe7': 'c',
          '\xd0': 'D',
          '\xf0': 'd',
          '\xc8': 'E',
          '\xc9': 'E',
          '\xca': 'E',
          '\xcb': 'E',
          '\xe8': 'e',
          '\xe9': 'e',
          '\xea': 'e',
          '\xeb': 'e',
          '\xcc': 'I',
          '\xcd': 'I',
          '\xce': 'I',
          '\xcf': 'I',
          '\xec': 'i',
          '\xed': 'i',
          '\xee': 'i',
          '\xef': 'i',
          '\xd1': 'N',
          '\xf1': 'n',
          '\xd2': 'O',
          '\xd3': 'O',
          '\xd4': 'O',
          '\xd5': 'O',
          '\xd6': 'O',
          '\xd8': 'O',
          '\xf2': 'o',
          '\xf3': 'o',
          '\xf4': 'o',
          '\xf5': 'o',
          '\xf6': 'o',
          '\xf8': 'o',
          '\xd9': 'U',
          '\xda': 'U',
          '\xdb': 'U',
          '\xdc': 'U',
          '\xf9': 'u',
          '\xfa': 'u',
          '\xfb': 'u',
          '\xfc': 'u',
          '\xdd': 'Y',
          '\xfd': 'y',
          '\xff': 'y',
          '\xc6': 'Ae',
          '\xe6': 'ae',
          '\xde': 'Th',
          '\xfe': 'th',
          '\xdf': 'ss',
          // Latin Extended-A block.
          "\u0100": 'A',
          "\u0102": 'A',
          "\u0104": 'A',
          "\u0101": 'a',
          "\u0103": 'a',
          "\u0105": 'a',
          "\u0106": 'C',
          "\u0108": 'C',
          "\u010A": 'C',
          "\u010C": 'C',
          "\u0107": 'c',
          "\u0109": 'c',
          "\u010B": 'c',
          "\u010D": 'c',
          "\u010E": 'D',
          "\u0110": 'D',
          "\u010F": 'd',
          "\u0111": 'd',
          "\u0112": 'E',
          "\u0114": 'E',
          "\u0116": 'E',
          "\u0118": 'E',
          "\u011A": 'E',
          "\u0113": 'e',
          "\u0115": 'e',
          "\u0117": 'e',
          "\u0119": 'e',
          "\u011B": 'e',
          "\u011C": 'G',
          "\u011E": 'G',
          "\u0120": 'G',
          "\u0122": 'G',
          "\u011D": 'g',
          "\u011F": 'g',
          "\u0121": 'g',
          "\u0123": 'g',
          "\u0124": 'H',
          "\u0126": 'H',
          "\u0125": 'h',
          "\u0127": 'h',
          "\u0128": 'I',
          "\u012A": 'I',
          "\u012C": 'I',
          "\u012E": 'I',
          "\u0130": 'I',
          "\u0129": 'i',
          "\u012B": 'i',
          "\u012D": 'i',
          "\u012F": 'i',
          "\u0131": 'i',
          "\u0134": 'J',
          "\u0135": 'j',
          "\u0136": 'K',
          "\u0137": 'k',
          "\u0138": 'k',
          "\u0139": 'L',
          "\u013B": 'L',
          "\u013D": 'L',
          "\u013F": 'L',
          "\u0141": 'L',
          "\u013A": 'l',
          "\u013C": 'l',
          "\u013E": 'l',
          "\u0140": 'l',
          "\u0142": 'l',
          "\u0143": 'N',
          "\u0145": 'N',
          "\u0147": 'N',
          "\u014A": 'N',
          "\u0144": 'n',
          "\u0146": 'n',
          "\u0148": 'n',
          "\u014B": 'n',
          "\u014C": 'O',
          "\u014E": 'O',
          "\u0150": 'O',
          "\u014D": 'o',
          "\u014F": 'o',
          "\u0151": 'o',
          "\u0154": 'R',
          "\u0156": 'R',
          "\u0158": 'R',
          "\u0155": 'r',
          "\u0157": 'r',
          "\u0159": 'r',
          "\u015A": 'S',
          "\u015C": 'S',
          "\u015E": 'S',
          "\u0160": 'S',
          "\u015B": 's',
          "\u015D": 's',
          "\u015F": 's',
          "\u0161": 's',
          "\u0162": 'T',
          "\u0164": 'T',
          "\u0166": 'T',
          "\u0163": 't',
          "\u0165": 't',
          "\u0167": 't',
          "\u0168": 'U',
          "\u016A": 'U',
          "\u016C": 'U',
          "\u016E": 'U',
          "\u0170": 'U',
          "\u0172": 'U',
          "\u0169": 'u',
          "\u016B": 'u',
          "\u016D": 'u',
          "\u016F": 'u',
          "\u0171": 'u',
          "\u0173": 'u',
          "\u0174": 'W',
          "\u0175": 'w',
          "\u0176": 'Y',
          "\u0177": 'y',
          "\u0178": 'Y',
          "\u0179": 'Z',
          "\u017B": 'Z',
          "\u017D": 'Z',
          "\u017A": 'z',
          "\u017C": 'z',
          "\u017E": 'z',
          "\u0132": 'IJ',
          "\u0133": 'ij',
          "\u0152": 'Oe',
          "\u0153": 'oe',
          "\u0149": "'n",
          "\u017F": 's'
        };

        /**
         * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
         * letters to basic Latin letters.
         *
         * @private
         * @param {string} letter The matched letter to deburr.
         * @returns {string} Returns the deburred letter.
         */
        var deburrLetter = basePropertyOf(deburredLetters);
        module.exports = deburrLetter;

        /***/
      }, /* 23 */
      /***/function (module) {
        /**
         * The base implementation of `_.propertyOf` without support for deep paths.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Function} Returns the new accessor function.
         */
        function basePropertyOf(object) {
          return function (key) {
            return object == null ? undefined : object[key];
          };
        }
        module.exports = basePropertyOf;

        /***/
      }, /* 24 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        var asciiWords = __webpack_require__(25),
          hasUnicodeWord = __webpack_require__(26),
          toString = __webpack_require__(4),
          unicodeWords = __webpack_require__(27);

        /**
         * Splits `string` into an array of its words.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to inspect.
         * @param {RegExp|string} [pattern] The pattern to match words.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the words of `string`.
         * @example
         *
         * _.words('fred, barney, & pebbles');
         * // => ['fred', 'barney', 'pebbles']
         *
         * _.words('fred, barney, & pebbles', /[^, ]+/g);
         * // => ['fred', 'barney', '&', 'pebbles']
         */
        function words(string, pattern, guard) {
          string = toString(string);
          pattern = guard ? undefined : pattern;
          if (pattern === undefined) {
            return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
          }
          return string.match(pattern) || [];
        }
        module.exports = words;

        /***/
      }, /* 25 */
      /***/function (module) {
        /** Used to match words composed of alphanumeric characters. */
        var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

        /**
         * Splits an ASCII `string` into an array of its words.
         *
         * @private
         * @param {string} The string to inspect.
         * @returns {Array} Returns the words of `string`.
         */
        function asciiWords(string) {
          return string.match(reAsciiWord) || [];
        }
        module.exports = asciiWords;

        /***/
      }, /* 26 */
      /***/function (module) {
        /** Used to detect strings that need a more robust regexp to match words. */
        var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

        /**
         * Checks if `string` contains a word composed of Unicode symbols.
         *
         * @private
         * @param {string} string The string to inspect.
         * @returns {boolean} Returns `true` if a word is found, else `false`.
         */
        function hasUnicodeWord(string) {
          return reHasUnicodeWord.test(string);
        }
        module.exports = hasUnicodeWord;

        /***/
      }, /* 27 */
      /***/function (module) {
        /** Used to compose unicode character classes. */
        var rsAstralRange = "\\ud800-\\udfff",
          rsComboMarksRange = "\\u0300-\\u036f",
          reComboHalfMarksRange = "\\ufe20-\\ufe2f",
          rsComboSymbolsRange = "\\u20d0-\\u20ff",
          rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
          rsDingbatRange = "\\u2700-\\u27bf",
          rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
          rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
          rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
          rsPunctuationRange = "\\u2000-\\u206f",
          rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
          rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
          rsVarRange = "\\ufe0e\\ufe0f",
          rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

        /** Used to compose unicode capture groups. */
        var rsApos = "['\u2019]",
          rsBreak = '[' + rsBreakRange + ']',
          rsCombo = '[' + rsComboRange + ']',
          rsDigits = '\\d+',
          rsDingbat = '[' + rsDingbatRange + ']',
          rsLower = '[' + rsLowerRange + ']',
          rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
          rsFitz = "\\ud83c[\\udffb-\\udfff]",
          rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
          rsNonAstral = '[^' + rsAstralRange + ']',
          rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
          rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
          rsUpper = '[' + rsUpperRange + ']',
          rsZWJ = "\\u200d";

        /** Used to compose unicode regexes. */
        var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
          rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
          rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
          rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
          reOptMod = rsModifier + '?',
          rsOptVar = '[' + rsVarRange + ']?',
          rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
          rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
          rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
          rsSeq = rsOptVar + reOptMod + rsOptJoin,
          rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

        /** Used to match complex or compound words. */
        var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')', rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower, rsUpper + '+' + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join('|'), 'g');

        /**
         * Splits a Unicode `string` into an array of its words.
         *
         * @private
         * @param {string} The string to inspect.
         * @returns {Array} Returns the words of `string`.
         */
        function unicodeWords(string) {
          return string.match(reUnicodeWord) || [];
        }
        module.exports = unicodeWords;

        /***/
      }, /* 28 */
      /***/function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */
        });
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29);
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

        /* harmony default export */
        var __WEBPACK_DEFAULT_EXPORT__ = prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
          moveLeft: prop_types__WEBPACK_IMPORTED_MODULE_0___default().node.isRequired,
          moveAllLeft: prop_types__WEBPACK_IMPORTED_MODULE_0___default().node.isRequired,
          moveRight: prop_types__WEBPACK_IMPORTED_MODULE_0___default().node.isRequired,
          moveAllRight: prop_types__WEBPACK_IMPORTED_MODULE_0___default().node.isRequired,
          // Optional properties
          moveBottom: prop_types__WEBPACK_IMPORTED_MODULE_0___default().node,
          moveDown: prop_types__WEBPACK_IMPORTED_MODULE_0___default().node,
          moveUp: prop_types__WEBPACK_IMPORTED_MODULE_0___default().node,
          moveTop: prop_types__WEBPACK_IMPORTED_MODULE_0___default().node
        });

        /***/
      }, /* 29 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        if (process.env.NODE_ENV !== 'production') {
          var ReactIs = __webpack_require__(30);

          // By explicitly using `prop-types` you are opting into new development behavior.
          // http://fb.me/prop-types-in-prod
          var throwOnDirectAccess = true;
          module.exports = __webpack_require__(33)(ReactIs.isElement, throwOnDirectAccess);
        } else {
          // By explicitly using `prop-types` you are opting into new production behavior.
          // http://fb.me/prop-types-in-prod
          module.exports = __webpack_require__(38)();
        }

        /***/
      }, /* 30 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        "use strict";

        if (process.env.NODE_ENV === 'production') {
          module.exports = __webpack_require__(31);
        } else {
          module.exports = __webpack_require__(32);
        }

        /***/
      }, /* 31 */
      /***/function (__unused_webpack_module, exports) {
        "use strict";

        /** @license React v16.13.1
         * react-is.production.min.js
         *
         * Copyright (c) Facebook, Inc. and its affiliates.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        var b = "function" === typeof Symbol && Symbol.for,
          c = b ? Symbol.for("react.element") : 60103,
          d = b ? Symbol.for("react.portal") : 60106,
          e = b ? Symbol.for("react.fragment") : 60107,
          f = b ? Symbol.for("react.strict_mode") : 60108,
          g = b ? Symbol.for("react.profiler") : 60114,
          h = b ? Symbol.for("react.provider") : 60109,
          k = b ? Symbol.for("react.context") : 60110,
          l = b ? Symbol.for("react.async_mode") : 60111,
          m = b ? Symbol.for("react.concurrent_mode") : 60111,
          n = b ? Symbol.for("react.forward_ref") : 60112,
          p = b ? Symbol.for("react.suspense") : 60113,
          q = b ? Symbol.for("react.suspense_list") : 60120,
          r = b ? Symbol.for("react.memo") : 60115,
          t = b ? Symbol.for("react.lazy") : 60116,
          v = b ? Symbol.for("react.block") : 60121,
          w = b ? Symbol.for("react.fundamental") : 60117,
          x = b ? Symbol.for("react.responder") : 60118,
          y = b ? Symbol.for("react.scope") : 60119;
        function z(a) {
          if ("object" === typeof a && null !== a) {
            var u = a.$$typeof;
            switch (u) {
              case c:
                switch (a = a.type, a) {
                  case l:
                  case m:
                  case e:
                  case g:
                  case f:
                  case p:
                    return a;
                  default:
                    switch (a = a && a.$$typeof, a) {
                      case k:
                      case n:
                      case t:
                      case r:
                      case h:
                        return a;
                      default:
                        return u;
                    }
                }
              case d:
                return u;
            }
          }
        }
        function A(a) {
          return z(a) === m;
        }
        exports.AsyncMode = l;
        exports.ConcurrentMode = m;
        exports.ContextConsumer = k;
        exports.ContextProvider = h;
        exports.Element = c;
        exports.ForwardRef = n;
        exports.Fragment = e;
        exports.Lazy = t;
        exports.Memo = r;
        exports.Portal = d;
        exports.Profiler = g;
        exports.StrictMode = f;
        exports.Suspense = p;
        exports.isAsyncMode = function (a) {
          return A(a) || z(a) === l;
        };
        exports.isConcurrentMode = A;
        exports.isContextConsumer = function (a) {
          return z(a) === k;
        };
        exports.isContextProvider = function (a) {
          return z(a) === h;
        };
        exports.isElement = function (a) {
          return "object" === typeof a && null !== a && a.$$typeof === c;
        };
        exports.isForwardRef = function (a) {
          return z(a) === n;
        };
        exports.isFragment = function (a) {
          return z(a) === e;
        };
        exports.isLazy = function (a) {
          return z(a) === t;
        };
        exports.isMemo = function (a) {
          return z(a) === r;
        };
        exports.isPortal = function (a) {
          return z(a) === d;
        };
        exports.isProfiler = function (a) {
          return z(a) === g;
        };
        exports.isStrictMode = function (a) {
          return z(a) === f;
        };
        exports.isSuspense = function (a) {
          return z(a) === p;
        };
        exports.isValidElementType = function (a) {
          return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
        };
        exports.typeOf = z;

        /***/
      }, /* 32 */
      /***/function (__unused_webpack_module, exports) {
        "use strict";

        /** @license React v16.13.1
         * react-is.development.js
         *
         * Copyright (c) Facebook, Inc. and its affiliates.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        if (process.env.NODE_ENV !== "production") {
          (function () {
            'use strict';

            // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
            // nor polyfill, then a plain number is used for performance.
            var hasSymbol = typeof Symbol === 'function' && Symbol.for;
            var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
            var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
            var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
            var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
            var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
            var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
            var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
            // (unstable) APIs that have been removed. Can we remove the symbols?

            var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
            var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
            var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
            var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
            var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
            var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
            var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
            var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
            var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
            var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
            var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
            function isValidElementType(type) {
              return typeof type === 'string' || typeof type === 'function' ||
              // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
              type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
            }
            function typeOf(object) {
              if (typeof object === 'object' && object !== null) {
                var $$typeof = object.$$typeof;
                switch ($$typeof) {
                  case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch (type) {
                      case REACT_ASYNC_MODE_TYPE:
                      case REACT_CONCURRENT_MODE_TYPE:
                      case REACT_FRAGMENT_TYPE:
                      case REACT_PROFILER_TYPE:
                      case REACT_STRICT_MODE_TYPE:
                      case REACT_SUSPENSE_TYPE:
                        return type;
                      default:
                        var $$typeofType = type && type.$$typeof;
                        switch ($$typeofType) {
                          case REACT_CONTEXT_TYPE:
                          case REACT_FORWARD_REF_TYPE:
                          case REACT_LAZY_TYPE:
                          case REACT_MEMO_TYPE:
                          case REACT_PROVIDER_TYPE:
                            return $$typeofType;
                          default:
                            return $$typeof;
                        }
                    }
                  case REACT_PORTAL_TYPE:
                    return $$typeof;
                }
              }
              return undefined;
            } // AsyncMode is deprecated along with isAsyncMode

            var AsyncMode = REACT_ASYNC_MODE_TYPE;
            var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
            var ContextConsumer = REACT_CONTEXT_TYPE;
            var ContextProvider = REACT_PROVIDER_TYPE;
            var Element = REACT_ELEMENT_TYPE;
            var ForwardRef = REACT_FORWARD_REF_TYPE;
            var Fragment = REACT_FRAGMENT_TYPE;
            var Lazy = REACT_LAZY_TYPE;
            var Memo = REACT_MEMO_TYPE;
            var Portal = REACT_PORTAL_TYPE;
            var Profiler = REACT_PROFILER_TYPE;
            var StrictMode = REACT_STRICT_MODE_TYPE;
            var Suspense = REACT_SUSPENSE_TYPE;
            var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

            function isAsyncMode(object) {
              {
                if (!hasWarnedAboutDeprecatedIsAsyncMode) {
                  hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

                  console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
                }
              }
              return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
            }
            function isConcurrentMode(object) {
              return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
            }
            function isContextConsumer(object) {
              return typeOf(object) === REACT_CONTEXT_TYPE;
            }
            function isContextProvider(object) {
              return typeOf(object) === REACT_PROVIDER_TYPE;
            }
            function isElement(object) {
              return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
            }
            function isForwardRef(object) {
              return typeOf(object) === REACT_FORWARD_REF_TYPE;
            }
            function isFragment(object) {
              return typeOf(object) === REACT_FRAGMENT_TYPE;
            }
            function isLazy(object) {
              return typeOf(object) === REACT_LAZY_TYPE;
            }
            function isMemo(object) {
              return typeOf(object) === REACT_MEMO_TYPE;
            }
            function isPortal(object) {
              return typeOf(object) === REACT_PORTAL_TYPE;
            }
            function isProfiler(object) {
              return typeOf(object) === REACT_PROFILER_TYPE;
            }
            function isStrictMode(object) {
              return typeOf(object) === REACT_STRICT_MODE_TYPE;
            }
            function isSuspense(object) {
              return typeOf(object) === REACT_SUSPENSE_TYPE;
            }
            exports.AsyncMode = AsyncMode;
            exports.ConcurrentMode = ConcurrentMode;
            exports.ContextConsumer = ContextConsumer;
            exports.ContextProvider = ContextProvider;
            exports.Element = Element;
            exports.ForwardRef = ForwardRef;
            exports.Fragment = Fragment;
            exports.Lazy = Lazy;
            exports.Memo = Memo;
            exports.Portal = Portal;
            exports.Profiler = Profiler;
            exports.StrictMode = StrictMode;
            exports.Suspense = Suspense;
            exports.isAsyncMode = isAsyncMode;
            exports.isConcurrentMode = isConcurrentMode;
            exports.isContextConsumer = isContextConsumer;
            exports.isContextProvider = isContextProvider;
            exports.isElement = isElement;
            exports.isForwardRef = isForwardRef;
            exports.isFragment = isFragment;
            exports.isLazy = isLazy;
            exports.isMemo = isMemo;
            exports.isPortal = isPortal;
            exports.isProfiler = isProfiler;
            exports.isStrictMode = isStrictMode;
            exports.isSuspense = isSuspense;
            exports.isValidElementType = isValidElementType;
            exports.typeOf = typeOf;
          })();
        }

        /***/
      }, /* 33 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        "use strict";

        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        var ReactIs = __webpack_require__(30);
        var assign = __webpack_require__(34);
        var ReactPropTypesSecret = __webpack_require__(35);
        var has = __webpack_require__(36);
        var checkPropTypes = __webpack_require__(37);
        var printWarning = function printWarning() {};
        if (process.env.NODE_ENV !== 'production') {
          printWarning = function printWarning(text) {
            var message = 'Warning: ' + text;
            if (typeof console !== 'undefined') {
              console.error(message);
            }
            try {
              // --- Welcome to debugging React ---
              // This error was thrown as a convenience so that you can use this stack
              // to find the callsite that caused this warning to fire.
              throw new Error(message);
            } catch (x) {}
          };
        }
        function emptyFunctionThatReturnsNull() {
          return null;
        }
        module.exports = function (isValidElement, throwOnDirectAccess) {
          /* global Symbol */
          var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
          var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

          /**
           * Returns the iterator method function contained on the iterable object.
           *
           * Be sure to invoke the function with the iterable as context:
           *
           *     var iteratorFn = getIteratorFn(myIterable);
           *     if (iteratorFn) {
           *       var iterator = iteratorFn.call(myIterable);
           *       ...
           *     }
           *
           * @param {?object} maybeIterable
           * @return {?function}
           */
          function getIteratorFn(maybeIterable) {
            var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
            if (typeof iteratorFn === 'function') {
              return iteratorFn;
            }
          }

          /**
           * Collection of methods that allow declaration and validation of props that are
           * supplied to React components. Example usage:
           *
           *   var Props = require('ReactPropTypes');
           *   var MyArticle = React.createClass({
           *     propTypes: {
           *       // An optional string prop named "description".
           *       description: Props.string,
           *
           *       // A required enum prop named "category".
           *       category: Props.oneOf(['News','Photos']).isRequired,
           *
           *       // A prop named "dialog" that requires an instance of Dialog.
           *       dialog: Props.instanceOf(Dialog).isRequired
           *     },
           *     render: function() { ... }
           *   });
           *
           * A more formal specification of how these methods are used:
           *
           *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
           *   decl := ReactPropTypes.{type}(.isRequired)?
           *
           * Each and every declaration produces a function with the same signature. This
           * allows the creation of custom validation functions. For example:
           *
           *  var MyLink = React.createClass({
           *    propTypes: {
           *      // An optional string or URI prop named "href".
           *      href: function(props, propName, componentName) {
           *        var propValue = props[propName];
           *        if (propValue != null && typeof propValue !== 'string' &&
           *            !(propValue instanceof URI)) {
           *          return new Error(
           *            'Expected a string or an URI for ' + propName + ' in ' +
           *            componentName
           *          );
           *        }
           *      }
           *    },
           *    render: function() {...}
           *  });
           *
           * @internal
           */

          var ANONYMOUS = '<<anonymous>>';

          // Important!
          // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
          var ReactPropTypes = {
            array: createPrimitiveTypeChecker('array'),
            bigint: createPrimitiveTypeChecker('bigint'),
            bool: createPrimitiveTypeChecker('boolean'),
            func: createPrimitiveTypeChecker('function'),
            number: createPrimitiveTypeChecker('number'),
            object: createPrimitiveTypeChecker('object'),
            string: createPrimitiveTypeChecker('string'),
            symbol: createPrimitiveTypeChecker('symbol'),
            any: createAnyTypeChecker(),
            arrayOf: createArrayOfTypeChecker,
            element: createElementTypeChecker(),
            elementType: createElementTypeTypeChecker(),
            instanceOf: createInstanceTypeChecker,
            node: createNodeChecker(),
            objectOf: createObjectOfTypeChecker,
            oneOf: createEnumTypeChecker,
            oneOfType: createUnionTypeChecker,
            shape: createShapeTypeChecker,
            exact: createStrictShapeTypeChecker
          };

          /**
           * inlined Object.is polyfill to avoid requiring consumers ship their own
           * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
           */
          /*eslint-disable no-self-compare*/
          function is(x, y) {
            // SameValue algorithm
            if (x === y) {
              // Steps 1-5, 7-10
              // Steps 6.b-6.e: +0 != -0
              return x !== 0 || 1 / x === 1 / y;
            } else {
              // Step 6.a: NaN == NaN
              return x !== x && y !== y;
            }
          }
          /*eslint-enable no-self-compare*/

          /**
           * We use an Error-like object for backward compatibility as people may call
           * PropTypes directly and inspect their output. However, we don't use real
           * Errors anymore. We don't inspect their stack anyway, and creating them
           * is prohibitively expensive if they are created too often, such as what
           * happens in oneOfType() for any type before the one that matched.
           */
          function PropTypeError(message, data) {
            this.message = message;
            this.data = data && typeof data === 'object' ? data : {};
            this.stack = '';
          }
          // Make `instanceof Error` still work for returned errors.
          PropTypeError.prototype = Error.prototype;
          function createChainableTypeChecker(validate) {
            if (process.env.NODE_ENV !== 'production') {
              var manualPropTypeCallCache = {};
              var manualPropTypeWarningCount = 0;
            }
            function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
              componentName = componentName || ANONYMOUS;
              propFullName = propFullName || propName;
              if (secret !== ReactPropTypesSecret) {
                if (throwOnDirectAccess) {
                  // New behavior only for users of `prop-types` package
                  var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
                  err.name = 'Invariant Violation';
                  throw err;
                } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
                  // Old behavior for people using React.PropTypes
                  var cacheKey = componentName + ':' + propName;
                  if (!manualPropTypeCallCache[cacheKey] &&
                  // Avoid spamming the console because they are often not actionable except for lib authors
                  manualPropTypeWarningCount < 3) {
                    printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                    manualPropTypeCallCache[cacheKey] = true;
                    manualPropTypeWarningCount++;
                  }
                }
              }
              if (props[propName] == null) {
                if (isRequired) {
                  if (props[propName] === null) {
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                  }
                  return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }
                return null;
              } else {
                return validate(props, propName, componentName, location, propFullName);
              }
            }
            var chainedCheckType = checkType.bind(null, false);
            chainedCheckType.isRequired = checkType.bind(null, true);
            return chainedCheckType;
          }
          function createPrimitiveTypeChecker(expectedType) {
            function validate(props, propName, componentName, location, propFullName, secret) {
              var propValue = props[propName];
              var propType = getPropType(propValue);
              if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
                  expectedType: expectedType
                });
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createAnyTypeChecker() {
            return createChainableTypeChecker(emptyFunctionThatReturnsNull);
          }
          function createArrayOfTypeChecker(typeChecker) {
            function validate(props, propName, componentName, location, propFullName) {
              if (typeof typeChecker !== 'function') {
                return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
              }
              var propValue = props[propName];
              if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
              }
              for (var i = 0; i < propValue.length; i++) {
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
                if (error instanceof Error) {
                  return error;
                }
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createElementTypeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];
              if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createElementTypeTypeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];
              if (!ReactIs.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createInstanceTypeChecker(expectedClass) {
            function validate(props, propName, componentName, location, propFullName) {
              if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createEnumTypeChecker(expectedValues) {
            if (!Array.isArray(expectedValues)) {
              if (process.env.NODE_ENV !== 'production') {
                if (arguments.length > 1) {
                  printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
                } else {
                  printWarning('Invalid argument supplied to oneOf, expected an array.');
                }
              }
              return emptyFunctionThatReturnsNull;
            }
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];
              for (var i = 0; i < expectedValues.length; i++) {
                if (is(propValue, expectedValues[i])) {
                  return null;
                }
              }
              var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === 'symbol') {
                  return String(value);
                }
                return value;
              });
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
            }
            return createChainableTypeChecker(validate);
          }
          function createObjectOfTypeChecker(typeChecker) {
            function validate(props, propName, componentName, location, propFullName) {
              if (typeof typeChecker !== 'function') {
                return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
              }
              var propValue = props[propName];
              var propType = getPropType(propValue);
              if (propType !== 'object') {
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
              }
              for (var key in propValue) {
                if (has(propValue, key)) {
                  var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                  if (error instanceof Error) {
                    return error;
                  }
                }
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createUnionTypeChecker(arrayOfTypeCheckers) {
            if (!Array.isArray(arrayOfTypeCheckers)) {
              process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
              return emptyFunctionThatReturnsNull;
            }
            for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
              var checker = arrayOfTypeCheckers[i];
              if (typeof checker !== 'function') {
                printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                return emptyFunctionThatReturnsNull;
              }
            }
            function validate(props, propName, componentName, location, propFullName) {
              var expectedTypes = [];
              for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
                if (checkerResult == null) {
                  return null;
                }
                if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
                  expectedTypes.push(checkerResult.data.expectedType);
                }
              }
              var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
            }
            return createChainableTypeChecker(validate);
          }
          function createNodeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
              if (!isNode(props[propName])) {
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function invalidValidatorError(componentName, location, propFullName, key, type) {
            return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
          }
          function createShapeTypeChecker(shapeTypes) {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];
              var propType = getPropType(propValue);
              if (propType !== 'object') {
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
              }
              for (var key in shapeTypes) {
                var checker = shapeTypes[key];
                if (typeof checker !== 'function') {
                  return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                }
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                if (error) {
                  return error;
                }
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createStrictShapeTypeChecker(shapeTypes) {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];
              var propType = getPropType(propValue);
              if (propType !== 'object') {
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
              }
              // We need to check all keys in case some are required but missing from props.
              var allKeys = assign({}, props[propName], shapeTypes);
              for (var key in allKeys) {
                var checker = shapeTypes[key];
                if (has(shapeTypes, key) && typeof checker !== 'function') {
                  return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                }
                if (!checker) {
                  return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                }
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                if (error) {
                  return error;
                }
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function isNode(propValue) {
            switch (typeof propValue) {
              case 'number':
              case 'string':
              case 'undefined':
                return true;
              case 'boolean':
                return !propValue;
              case 'object':
                if (Array.isArray(propValue)) {
                  return propValue.every(isNode);
                }
                if (propValue === null || isValidElement(propValue)) {
                  return true;
                }
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                  var iterator = iteratorFn.call(propValue);
                  var step;
                  if (iteratorFn !== propValue.entries) {
                    while (!(step = iterator.next()).done) {
                      if (!isNode(step.value)) {
                        return false;
                      }
                    }
                  } else {
                    // Iterator will provide entry [k,v] tuples rather than values.
                    while (!(step = iterator.next()).done) {
                      var entry = step.value;
                      if (entry) {
                        if (!isNode(entry[1])) {
                          return false;
                        }
                      }
                    }
                  }
                } else {
                  return false;
                }
                return true;
              default:
                return false;
            }
          }
          function isSymbol(propType, propValue) {
            // Native Symbol.
            if (propType === 'symbol') {
              return true;
            }

            // falsy value can't be a Symbol
            if (!propValue) {
              return false;
            }

            // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
            if (propValue['@@toStringTag'] === 'Symbol') {
              return true;
            }

            // Fallback for non-spec compliant Symbols which are polyfilled.
            if (typeof Symbol === 'function' && propValue instanceof Symbol) {
              return true;
            }
            return false;
          }

          // Equivalent of `typeof` but with special handling for array and regexp.
          function getPropType(propValue) {
            var propType = typeof propValue;
            if (Array.isArray(propValue)) {
              return 'array';
            }
            if (propValue instanceof RegExp) {
              // Old webkits (at least until Android 4.0) return 'function' rather than
              // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
              // passes PropTypes.object.
              return 'object';
            }
            if (isSymbol(propType, propValue)) {
              return 'symbol';
            }
            return propType;
          }

          // This handles more types than `getPropType`. Only used for error messages.
          // See `createPrimitiveTypeChecker`.
          function getPreciseType(propValue) {
            if (typeof propValue === 'undefined' || propValue === null) {
              return '' + propValue;
            }
            var propType = getPropType(propValue);
            if (propType === 'object') {
              if (propValue instanceof Date) {
                return 'date';
              } else if (propValue instanceof RegExp) {
                return 'regexp';
              }
            }
            return propType;
          }

          // Returns a string that is postfixed to a warning about an invalid type.
          // For example, "undefined" or "of type array"
          function getPostfixForTypeWarning(value) {
            var type = getPreciseType(value);
            switch (type) {
              case 'array':
              case 'object':
                return 'an ' + type;
              case 'boolean':
              case 'date':
              case 'regexp':
                return 'a ' + type;
              default:
                return type;
            }
          }

          // Returns class name of the object, if any.
          function getClassName(propValue) {
            if (!propValue.constructor || !propValue.constructor.name) {
              return ANONYMOUS;
            }
            return propValue.constructor.name;
          }
          ReactPropTypes.checkPropTypes = checkPropTypes;
          ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
          ReactPropTypes.PropTypes = ReactPropTypes;
          return ReactPropTypes;
        };

        /***/
      }, /* 34 */
      /***/function (module) {
        "use strict";

        /*
        object-assign
        (c) Sindre Sorhus
        @license MIT
        */

        /* eslint-disable no-unused-vars */
        var getOwnPropertySymbols = Object.getOwnPropertySymbols;
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var propIsEnumerable = Object.prototype.propertyIsEnumerable;
        function toObject(val) {
          if (val === null || val === undefined) {
            throw new TypeError('Object.assign cannot be called with null or undefined');
          }
          return Object(val);
        }
        function shouldUseNative() {
          try {
            if (!Object.assign) {
              return false;
            }

            // Detect buggy property enumeration order in older V8 versions.

            // https://bugs.chromium.org/p/v8/issues/detail?id=4118
            var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
            test1[5] = 'de';
            if (Object.getOwnPropertyNames(test1)[0] === '5') {
              return false;
            }

            // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test2 = {};
            for (var i = 0; i < 10; i++) {
              test2['_' + String.fromCharCode(i)] = i;
            }
            var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
              return test2[n];
            });
            if (order2.join('') !== '0123456789') {
              return false;
            }

            // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test3 = {};
            'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
              test3[letter] = letter;
            });
            if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
              return false;
            }
            return true;
          } catch (err) {
            // We don't expect any of the above to throw, but better to be safe.
            return false;
          }
        }
        module.exports = shouldUseNative() ? Object.assign : function (target, source) {
          var from;
          var to = toObject(target);
          var symbols;
          for (var s = 1; s < arguments.length; s++) {
            from = Object(arguments[s]);
            for (var key in from) {
              if (hasOwnProperty.call(from, key)) {
                to[key] = from[key];
              }
            }
            if (getOwnPropertySymbols) {
              symbols = getOwnPropertySymbols(from);
              for (var i = 0; i < symbols.length; i++) {
                if (propIsEnumerable.call(from, symbols[i])) {
                  to[symbols[i]] = from[symbols[i]];
                }
              }
            }
          }
          return to;
        };

        /***/
      }, /* 35 */
      /***/function (module) {
        "use strict";

        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
        module.exports = ReactPropTypesSecret;

        /***/
      }, /* 36 */
      /***/function (module) {
        module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

        /***/
      }, /* 37 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        "use strict";

        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        var printWarning = function printWarning() {};
        if (process.env.NODE_ENV !== 'production') {
          var ReactPropTypesSecret = __webpack_require__(35);
          var loggedTypeFailures = {};
          var has = __webpack_require__(36);
          printWarning = function printWarning(text) {
            var message = 'Warning: ' + text;
            if (typeof console !== 'undefined') {
              console.error(message);
            }
            try {
              // --- Welcome to debugging React ---
              // This error was thrown as a convenience so that you can use this stack
              // to find the callsite that caused this warning to fire.
              throw new Error(message);
            } catch (x) {/**/}
          };
        }

        /**
         * Assert that the values match with the type specs.
         * Error messages are memorized and will only be shown once.
         *
         * @param {object} typeSpecs Map of name to a ReactPropType
         * @param {object} values Runtime values that need to be type-checked
         * @param {string} location e.g. "prop", "context", "child context"
         * @param {string} componentName Name of the component for error messages.
         * @param {?Function} getStack Returns the component stack.
         * @private
         */
        function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
          if (process.env.NODE_ENV !== 'production') {
            for (var typeSpecName in typeSpecs) {
              if (has(typeSpecs, typeSpecName)) {
                var error;
                // Prop type validation may throw. In case they do, we don't want to
                // fail the render phase where it didn't fail before. So we log it.
                // After these have been cleaned up, we'll let them throw.
                try {
                  // This is intentionally an invariant that gets caught. It's the same
                  // behavior as without this statement except with a better message.
                  if (typeof typeSpecs[typeSpecName] !== 'function') {
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                  }
                  error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                } catch (ex) {
                  error = ex;
                }
                if (error && !(error instanceof Error)) {
                  printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
                }
                if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                  // Only monitor this failure once because there tends to be a lot of the
                  // same error.
                  loggedTypeFailures[error.message] = true;
                  var stack = getStack ? getStack() : '';
                  printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
                }
              }
            }
          }
        }

        /**
         * Resets warning cache when testing.
         *
         * @private
         */
        checkPropTypes.resetWarningCache = function () {
          if (process.env.NODE_ENV !== 'production') {
            loggedTypeFailures = {};
          }
        };
        module.exports = checkPropTypes;

        /***/
      }, /* 38 */
      /***/function (module, __unused_webpack_exports, __webpack_require__) {
        "use strict";

        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        var ReactPropTypesSecret = __webpack_require__(35);
        function emptyFunction() {}
        function emptyFunctionWithReset() {}
        emptyFunctionWithReset.resetWarningCache = emptyFunction;
        module.exports = function () {
          function shim(props, propName, componentName, location, propFullName, secret) {
            if (secret === ReactPropTypesSecret) {
              // It is still safe when called from React.
              return;
            }
            var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
            err.name = 'Invariant Violation';
            throw err;
          }
          ;
          shim.isRequired = shim;
          function getShim() {
            return shim;
          }
          ;
          // Important!
          // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
          var ReactPropTypes = {
            array: shim,
            bigint: shim,
            bool: shim,
            func: shim,
            number: shim,
            object: shim,
            string: shim,
            symbol: shim,
            any: shim,
            arrayOf: getShim,
            element: shim,
            elementType: shim,
            instanceOf: getShim,
            node: shim,
            objectOf: getShim,
            oneOf: getShim,
            oneOfType: getShim,
            shape: getShim,
            exact: getShim,
            checkPropTypes: emptyFunctionWithReset,
            resetWarningCache: emptyFunction
          };
          ReactPropTypes.PropTypes = ReactPropTypes;
          return ReactPropTypes;
        };

        /***/
      }, /* 39 */
      /***/function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */
        });
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29);
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

        /* harmony default export */
        var __WEBPACK_DEFAULT_EXPORT__ = prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
          moveLeft: prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired,
          moveAllLeft: prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired,
          moveRight: prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired,
          moveAllRight: prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired,
          // Optional properties
          availableFilterHeader: prop_types__WEBPACK_IMPORTED_MODULE_0___default().string,
          availableHeader: prop_types__WEBPACK_IMPORTED_MODULE_0___default().string,
          filterPlaceholder: prop_types__WEBPACK_IMPORTED_MODULE_0___default().string,
          moveDown: prop_types__WEBPACK_IMPORTED_MODULE_0___default().string,
          moveUp: prop_types__WEBPACK_IMPORTED_MODULE_0___default().string,
          noAvailableOptions: prop_types__WEBPACK_IMPORTED_MODULE_0___default().string,
          noSelectedOptions: prop_types__WEBPACK_IMPORTED_MODULE_0___default().string,
          requiredError: prop_types__WEBPACK_IMPORTED_MODULE_0___default().string,
          selectedFilterHeader: prop_types__WEBPACK_IMPORTED_MODULE_0___default().string,
          selectedHeader: prop_types__WEBPACK_IMPORTED_MODULE_0___default().string
        });

        /***/
      }, /* 40 */
      /***/function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */
        });
        /**
         * Capitalize the first letter of a given string.
         *
         * @param {string} str
         *
         * @returns {string}
         */
        function capitalizeFirstLetter(str) {
          return str.charAt(0).toUpperCase() + str.slice(1);
        }
        /* harmony default export */
        var __WEBPACK_DEFAULT_EXPORT__ = capitalizeFirstLetter;

        /***/
      }, /* 41 */
      /***/function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */
        });
        /* harmony import */
        var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
        /* harmony import */
        var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29);
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */
        var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16);
        /* harmony import */
        var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */
        var _Filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42);
        /* harmony import */
        var _shapes_languageShape__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39);
        /* harmony import */
        var _util_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40);
        function _defineProperty(obj, key, value) {
          key = _toPropertyKey(key);
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _toPropertyKey(arg) {
          var key = _toPrimitive(arg, "string");
          return typeof key === "symbol" ? key : String(key);
        }
        function _toPrimitive(input, hint) {
          if (typeof input !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];
          if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (hint === "string" ? String : Number)(input);
        }
        var ListBox = /*#__PURE__*/function (_react__WEBPACK_IMPOR2) {
          _inherits(ListBox, _react__WEBPACK_IMPOR2);
          function ListBox() {
            _classCallCheck(this, ListBox);
            return _possibleConstructorReturn(this, _getPrototypeOf(ListBox).apply(this, arguments));
          }
          _createClass(ListBox, [{
            key: "renderFilter",
            /**
             * @returns {ReactElement}
             */
            value: function renderFilter() {
              var _this$props8 = this.props,
                canFilter = _this$props8.canFilter,
                controlKey = _this$props8.controlKey,
                disabled = _this$props8.disabled,
                filterValue = _this$props8.filterValue,
                id = _this$props8.id,
                lang = _this$props8.lang,
                onFilterChange = _this$props8.onFilterChange;
              if (!canFilter) {
                return null;
              }
              return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_Filter__WEBPACK_IMPORTED_MODULE_2__["default"], {
                controlKey: controlKey,
                disabled: disabled,
                filterValue: filterValue,
                id: id,
                lang: lang,
                onFilterChange: onFilterChange
              });
            }
            /**
             * @returns {ReactElement}
             */
          }, {
            key: "renderSelect",
            value: function renderSelect() {
              var _this$props9 = this.props,
                actions = _this$props9.actions,
                children = _this$props9.children,
                disabled = _this$props9.disabled,
                controlKey = _this$props9.controlKey,
                id = _this$props9.id,
                inputRef = _this$props9.inputRef,
                lang = _this$props9.lang,
                selections = _this$props9.selections,
                showNoOptionsText = _this$props9.showNoOptionsText,
                onDoubleClick = _this$props9.onDoubleClick,
                onKeyUp = _this$props9.onKeyUp,
                onSelectionChange = _this$props9.onSelectionChange;
              if (showNoOptionsText && react__WEBPACK_IMPORTED_MODULE_1___default().Children.count(children) === 0) {
                return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
                  className: "rdl-no-options"
                }, lang["no".concat((0, _util_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_4__["default"])(controlKey), "Options")]);
              }
              return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
                className: "rdl-control-container"
              }, actions, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("select", {
                className: "rdl-control",
                disabled: disabled,
                id: "".concat(id, "-").concat(controlKey),
                multiple: true,
                ref: inputRef,
                value: selections,
                onChange: onSelectionChange,
                onDoubleClick: onDoubleClick,
                onKeyUp: onKeyUp
              }, children));
            }
          }, {
            key: "render",
            value: function render() {
              var _this$props10 = this.props,
                controlKey = _this$props10.controlKey,
                id = _this$props10.id,
                lang = _this$props10.lang,
                showHeaderLabels = _this$props10.showHeaderLabels;
              var labelClassName = classnames__WEBPACK_IMPORTED_MODULE_0___default()({
                'rdl-control-label': true,
                'rdl-sr-only': !showHeaderLabels
              });
              return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
                className: "rdl-list-box rdl-".concat(controlKey)
              }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("label", {
                className: labelClassName,
                htmlFor: "".concat(id, "-").concat(controlKey)
              }, lang["".concat(controlKey, "Header")]), this.renderFilter(), this.renderSelect());
            }
          }]);
          return ListBox;
        }(react__WEBPACK_IMPORTED_MODULE_1__.Component);
        _defineProperty(ListBox, "propTypes", {
          canFilter: prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool.isRequired,
          children: prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired,
          controlKey: prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired,
          disabled: prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool.isRequired,
          filterValue: prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired,
          id: prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired,
          inputRef: prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired,
          lang: _shapes_languageShape__WEBPACK_IMPORTED_MODULE_3__["default"].isRequired,
          selections: prop_types__WEBPACK_IMPORTED_MODULE_5___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_5___default().string, prop_types__WEBPACK_IMPORTED_MODULE_5___default().number])).isRequired,
          showHeaderLabels: prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool.isRequired,
          showNoOptionsText: prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool.isRequired,
          onDoubleClick: prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired,
          onFilterChange: prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired,
          onKeyUp: prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired,
          onSelectionChange: prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired,
          actions: prop_types__WEBPACK_IMPORTED_MODULE_5___default().node
        });
        _defineProperty(ListBox, "defaultProps", {
          actions: null
        });
        /* harmony default export */
        var __WEBPACK_DEFAULT_EXPORT__ = ListBox;

        /***/
      }, /* 42 */
      /***/function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */
        });
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29);
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */
        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
        /* harmony import */
        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */
        var _shapes_languageShape__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39);
        var propTypes = {
          controlKey: prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired,
          disabled: prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool.isRequired,
          filterValue: prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired,
          id: prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired,
          lang: _shapes_languageShape__WEBPACK_IMPORTED_MODULE_1__["default"].isRequired,
          onFilterChange: prop_types__WEBPACK_IMPORTED_MODULE_2___default().func.isRequired
        };
        function Filter(props) {
          var controlKey = props.controlKey,
            disabled = props.disabled,
            filterValue = props.filterValue,
            id = props.id,
            lang = props.lang,
            onFilterChange = props.onFilterChange;
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
            className: "rdl-filter-container"
          }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("label", {
            className: "rdl-control-label rdl-sr-only",
            htmlFor: "".concat(id, "-filter-").concat(controlKey)
          }, lang["".concat(controlKey, "FilterHeader")]), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
            className: "rdl-filter",
            "data-control-key": controlKey,
            disabled: disabled,
            id: "".concat(id, "-filter-").concat(controlKey),
            placeholder: lang.filterPlaceholder,
            type: "text",
            value: filterValue,
            onChange: onFilterChange
          }));
        }
        Filter.propTypes = propTypes;
        /* harmony default export */
        var __WEBPACK_DEFAULT_EXPORT__ = Filter;

        /***/
      }, /* 43 */
      /***/function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */
        });
        /* harmony default export */
        var __WEBPACK_DEFAULT_EXPORT__ = {
          availableFilterHeader: 'Filter available',
          availableHeader: 'Available',
          filterPlaceholder: 'Search...',
          moveAllLeft: 'Move all to available',
          moveAllRight: 'Move all to selected',
          moveLeft: 'Move to available',
          moveRight: 'Move to selected',
          moveBottom: 'Rearrange to bottom',
          moveDown: 'Rearrange down',
          moveUp: 'Rearrange up',
          moveTop: 'Rearrange to top',
          noAvailableOptions: 'No available options',
          noSelectedOptions: 'No selected options',
          requiredError: 'Please select at least one option.',
          selectedFilterHeader: 'Filter selected',
          selectedHeader: 'Selected'
        };

        /***/
      }, /* 44 */
      /***/function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */
        });
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29);
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */
        var _optionShape__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45);

        /* harmony default export */
        var __WEBPACK_DEFAULT_EXPORT__ = prop_types__WEBPACK_IMPORTED_MODULE_1___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([_optionShape__WEBPACK_IMPORTED_MODULE_0__["default"], prop_types__WEBPACK_IMPORTED_MODULE_1___default().shape({
          label: prop_types__WEBPACK_IMPORTED_MODULE_1___default().node.isRequired,
          options: prop_types__WEBPACK_IMPORTED_MODULE_1___default().arrayOf(_optionShape__WEBPACK_IMPORTED_MODULE_0__["default"]).isRequired,
          // Optional properties
          disabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool,
          title: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string
        })]));

        /***/
      }, /* 45 */
      /***/function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */
        });
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29);
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

        /* harmony default export */
        var __WEBPACK_DEFAULT_EXPORT__ = prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
          label: prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired,
          value: prop_types__WEBPACK_IMPORTED_MODULE_0___default().oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default().string, prop_types__WEBPACK_IMPORTED_MODULE_0___default().number]).isRequired,
          // Optional properties
          disabled: prop_types__WEBPACK_IMPORTED_MODULE_0___default().bool,
          title: prop_types__WEBPACK_IMPORTED_MODULE_0___default().string
        });

        /***/
      }, /* 46 */
      /***/function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */
        });
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29);
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */
        var _optionShape__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45);

        /* harmony default export */
        var __WEBPACK_DEFAULT_EXPORT__ = prop_types__WEBPACK_IMPORTED_MODULE_1___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default().string, _optionShape__WEBPACK_IMPORTED_MODULE_0__["default"], prop_types__WEBPACK_IMPORTED_MODULE_1___default().shape({
          value: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default().string, prop_types__WEBPACK_IMPORTED_MODULE_1___default().number]),
          options: prop_types__WEBPACK_IMPORTED_MODULE_1___default().arrayOf(_optionShape__WEBPACK_IMPORTED_MODULE_0__["default"])
        })]));

        /***/
      }, /* 47 */
      /***/function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function _default() {
            return (/* binding */indexesOf
            );
          }
          /* harmony export */
        });
        /**
         * Return an array of indexes for all instances of the given value.
         *
         * @param {Array} list
         * @param {*} value
         *
         * @returns {Array}
         */
        function indexesOf(list, value) {
          var indexes = [];
          list.forEach(function (listItem, index) {
            if (listItem === value) {
              indexes.push(index);
            }
          });
          return indexes;
        }

        /***/
      }, /* 48 */
      /***/function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */
        });
        /**
         * Return a function to swap positions of the given indexes in an ordering.
         *
         * @param {int} index1
         * @param {int} index2
         *
         * @returns {function}
         */
        /* harmony default export */
        var __WEBPACK_DEFAULT_EXPORT__ = function __WEBPACK_DEFAULT_EXPORT__(index1, index2) {
          return function (options) {
            var newOptions = _toConsumableArray(options);
            var _ref10 = [newOptions[index2], newOptions[index1]];
            newOptions[index1] = _ref10[0];
            newOptions[index2] = _ref10[1];
            return newOptions;
          };
        };

        /***/
      }, /* 49 */
      /***/function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"ALIGNMENTS": function ALIGNMENTS() {
            return (/* binding */_ALIGNMENTS
            );
          },
          /* harmony export */"KEYS": function KEYS() {
            return (/* binding */_KEYS
            );
          }
          /* harmony export */
        });
        var _KEYS = {
          SPACEBAR: ' ',
          ENTER: 'Enter'
        };
        var _ALIGNMENTS = {
          MIDDLE: 'middle',
          TOP: 'top'
        };

        /***/
      }, /* 50 */
      /***/function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"customAlphabet": function customAlphabet() {
            return (/* binding */_customAlphabet
            );
          },
          /* harmony export */"customRandom": function customRandom() {
            return (/* binding */_customRandom
            );
          },
          /* harmony export */"nanoid": function nanoid() {
            return (/* binding */_nanoid
            );
          },
          /* harmony export */"random": function random() {
            return (/* binding */_random
            );
          },
          /* harmony export */"urlAlphabet": function urlAlphabet() {
            return (/* reexport safe */_url_alphabet_index_js__WEBPACK_IMPORTED_MODULE_0__.urlAlphabet
            );
          }
          /* harmony export */
        });
        /* harmony import */
        var _url_alphabet_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51);
        var _random = function _random(bytes) {
          return crypto.getRandomValues(new Uint8Array(bytes));
        };
        var _customRandom = function _customRandom(alphabet, defaultSize, getRandom) {
          var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
          var step = -~(1.6 * mask * defaultSize / alphabet.length);
          return function () {
            var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSize;
            var id = '';
            while (true) {
              var bytes = getRandom(step);
              var j = step;
              while (j--) {
                id += alphabet[bytes[j] & mask] || '';
                if (id.length === size) return id;
              }
            }
          };
        };
        var _customAlphabet = function _customAlphabet(alphabet) {
          var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 21;
          return _customRandom(alphabet, size, _random);
        };
        var _nanoid = function _nanoid() {
          var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 21;
          return crypto.getRandomValues(new Uint8Array(size)).reduce(function (id, byte) {
            byte &= 63;
            if (byte < 36) {
              id += byte.toString(36);
            } else if (byte < 62) {
              id += (byte - 26).toString(36).toUpperCase();
            } else if (byte > 62) {
              id += '-';
            } else {
              id += '_';
            }
            return id;
          }, '');
        };

        /***/
      }, /* 51 */
      /***/function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"urlAlphabet": function urlAlphabet() {
            return (/* binding */_urlAlphabet
            );
          }
          /* harmony export */
        });
        var _urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

        /***/
      }
      /******/];
      /************************************************************************/
      /******/ // The module cache
      /******/
      var __webpack_module_cache__ = {};
      /******/
      /******/ // The require function
      /******/
      function __webpack_require__(moduleId) {
        /******/ // Check if module is in cache
        /******/var cachedModule = __webpack_module_cache__[moduleId];
        /******/
        if (cachedModule !== undefined) {
          /******/return cachedModule.exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/
        var module = __webpack_module_cache__[moduleId] = {
          /******/ // no module.id needed
          /******/ // no module.loaded needed
          /******/exports: {}
          /******/
        };
        /******/
        /******/ // Execute the module function
        /******/
        __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
        /******/
        /******/ // Return the exports of the module
        /******/
        return module.exports;
        /******/
      }
      /******/
      /************************************************************************/
      /******/ /* webpack/runtime/compat get default export */
      /******/
      (function () {
        /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/__webpack_require__.n = function (module) {
          /******/var getter = module && module.__esModule ? /******/function () {
            return module['default'];
          } : /******/function () {
            return module;
          };
          /******/
          __webpack_require__.d(getter, {
            a: getter
          });
          /******/
          return getter;
          /******/
        };
        /******/
      })();
      /******/
      /******/ /* webpack/runtime/define property getters */
      /******/
      (function () {
        /******/ // define getter functions for harmony exports
        /******/__webpack_require__.d = function (exports, definition) {
          /******/for (var key in definition) {
            /******/if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
              /******/Object.defineProperty(exports, key, {
                enumerable: true,
                get: definition[key]
              });
              /******/
            }
            /******/
          }
          /******/
        };
        /******/
      })();
      /******/
      /******/ /* webpack/runtime/global */
      /******/
      (function () {
        /******/__webpack_require__.g = function () {
          /******/if (typeof globalThis === 'object') return globalThis;
          /******/
          try {
            /******/return this || new Function('return this')();
            /******/
          } catch (e) {
            /******/if (typeof window === 'object') return window;
            /******/
          }
          /******/
        }();
        /******/
      })();
      /******/
      /******/ /* webpack/runtime/hasOwnProperty shorthand */
      /******/
      (function () {
        /******/__webpack_require__.o = function (obj, prop) {
          return Object.prototype.hasOwnProperty.call(obj, prop);
        };
        /******/
      })();
      /******/
      /******/ /* webpack/runtime/make namespace object */
      /******/
      (function () {
        /******/ // define __esModule on exports
        /******/__webpack_require__.r = function (exports) {
          /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
            /******/Object.defineProperty(exports, Symbol.toStringTag, {
              value: 'Module'
            });
            /******/
          }
          /******/
          Object.defineProperty(exports, '__esModule', {
            value: true
          });
          /******/
        };
        /******/
      })();
      /******/
      /************************************************************************/
      var __webpack_exports__ = {};
      // This entry need to be wrapped in an IIFE because it need to be in strict mode.
      (function () {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"DualListBox": function DualListBox() {
            return (/* reexport safe */_js_DualListBox__WEBPACK_IMPORTED_MODULE_0__["default"]
            );
          },
          /* harmony export */"default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */
        });
        /* harmony import */
        var _js_DualListBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);

        /* harmony default export */
        var __WEBPACK_DEFAULT_EXPORT__ = _js_DualListBox__WEBPACK_IMPORTED_MODULE_0__["default"];
      })();

      /******/
      return __webpack_exports__;
      /******/
    }()
  );
});